<template>
  <div
    id="tab-mbl"
  >
    <div class="section operations">
      <div v-show="cooperateEdit" class="triggers">
        <div>
          <el-dropdown
            no="1"
            :class="readonly?'not-click':''"
            split-button
            type="primary"
            @click="commandHandle(command1)"
            @command="p=>{command1=p;commandHandle(command1)}"
          >
            {{ command1 }}
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item :command="$t('SeaExport.CodeSearching')">{{
                $t('SeaExport.CodeSearching')
              }}
              </el-dropdown-item>
              <el-dropdown-item :command="$t('SeaExport.CopyFromTheLastTime')">{{
                $t('SeaExport.CopyFromTheLastTime')
              }}
              </el-dropdown-item>
              <el-dropdown-item :command="$t('SeaExport.CopyFromOtherBill')">{{
                $t('SeaExport.CopyFromOtherBill')
              }}
              </el-dropdown-item>
              <el-dropdown-item :command="$t('SeaExport.CopyFromHbl')">{{
                $t('SeaExport.CopyFromHbl')
              }}
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <el-button
            no="2"
            :disabled="feedBtnDisabled"
            type="primary"
            @click="pm.completefeedClickHandler()"
          >{{ $t('SeaExport.CompleteTheDetails') }}
          </el-button>
          <el-dropdown
            no="3"
            style="padding-left: 5px;"
            :class="btnBLConfirmDisabled?'not-click':''"
            split-button
            type="primary"
            @click="commandHandle(command2)"
            @command="p=>{command2=p;commandHandle(command2)}"
          >
            {{ command2 }}
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item :command="$t('SeaExport.InviteToChecktheBL')">{{
                $t('SeaExport.InviteToChecktheBL')
              }}
              </el-dropdown-item>
              <el-dropdown-item
                v-permission="['button_M/HBL_confirmBL']"
                :command="$t('SeaExport.ConfirmChecking')"
              >{{ $t('SeaExport.ConfirmChecking') }}
              </el-dropdown-item>
              <el-dropdown-item
                v-if="$checkPermission(['button_M/HBL_identification'])"
                :command="$t('SeaExport.IdentificationList')"
              >{{ $t('SeaExport.IdentificationList') }}
              </el-dropdown-item>
              <el-dropdown-item :command="$t('SeaExport.CheckingHistory')">{{
                $t('SeaExport.CheckingHistory')
              }}
              </el-dropdown-item>
              <el-dropdown-item :command="$t('SeaExport.ReceiptHistory')">{{
                $t('SeaExport.ReceiptHistory')
              }}
              </el-dropdown-item>
              <el-dropdown-item :command="$t('SeaExport.BillingOfLadingRecordManager')">{{
                $t('SeaExport.BillingOfLadingRecordManager')
              }}
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <el-button
            v-if="viewSource === 'SeBooking'"
            v-permission="['button_insurance_toInsure']"
            no="4"
            :disabled="isEdit"
            type="primary"
            @click="pm.toInsure()"
          >{{ $t('SeaExport.Insure') }}
          </el-button>
          <el-menu
            :disabled="!(action === 'look' && form.uuid)"
            text-color="#404144"
            active-text-color="#404144"
            mode="horizontal"
            class="el-menu-button el-button el-button--primary el-button--mini"
            :style="{width: $selectByLang('80px', '80px', '80px', '120px', '120px', '120px'), padding: '0', verticalAlign: 'top' }"
            @select="toBlPre"
          >
            <el-submenu index="index" :disabled="!(action === 'look' && form.uuid)">
              <span slot="title" class="el-menu-btn-text">{{ $t('SeaExport.EDIDoc') }}</span>
              <el-submenu index="original">
                <template slot="title">{{ $t('SeaExport.Original') }}</template>
                <el-menu-item index="API0" :disabled="!billEDIApiOpen">API</el-menu-item>
                <el-menu-item index="FTP1">FTP</el-menu-item>
              </el-submenu>
              <el-submenu index="correct">
                <template slot="title">{{ $t('SeaExport.Correct') }}</template>
                <el-menu-item index="FTP0">FTP</el-menu-item>
                <el-menu-item index="API1" :disabled="!billEDIApiOpen">API</el-menu-item>
              </el-submenu>
            </el-submenu>
          </el-menu>
          <el-button
            v-if="!job.masterFlag || (job.containerLoadType === LCL_CARGO_TYPE.code)"
            no="EdiEuBolInfo"
            :disabled="!(action === 'look' && form.uuid)"
            type="primary"
            @click="ediEuBolInfoHandler"
          >{{ $t('SeaExport.EdiEuBolInfo') }}</el-button>
          <el-button
            v-show="btnMergeHblDataVisible"
            no="5"
            :disabled="readonly"
            type="primary"
            @click="pm.mergeHblData()"
          >{{ $t('SeaExport.mergeHblData') }}
          </el-button>
          <el-menu
            v-show="!job.signHBL"
            v-permission="['button_EDI_overseasAgentForecast']"
            :class="isEdit?'is-disabled not-click':''"
            text-color="#404144"
            active-text-color="#404144"
            mode="horizontal"
            class="el-menu-button el-button el-button--primary el-button--mini"
            style="width: 100px;vertical-align: top"
            @select="toOverseaAgeFore"
          >
            <el-submenu index="index">
              <span slot="title" class="el-menu-btn-text">{{ $t('SeaExport.OverseasAgeFore') }}</span>
              <el-menu-item :index="$t('SeaExport.Original')">{{ $t('SeaExport.Original') }}</el-menu-item>
              <el-menu-item :index="$t('SeaExport.Correct')">{{ $t('SeaExport.Correct') }}</el-menu-item>
              <el-menu-item :index="$t('SeaExport.deleteSingle')">{{ $t('SeaExport.deleteSingle') }}</el-menu-item>
            </el-submenu>
          </el-menu>
          <el-checkbox
            no="6"
            :value="form.state>=2"
            :disabled="true"
            style="margin-left: 10px"
          >{{ $t('SeaExport.Printed') }}
          </el-checkbox>
          <el-checkbox
            no="7"
            style="margin-left: -20px;"
            :value="form.state===3"
            :disabled="true"
          >{{ $t('SeaExport.Locked') }}
          </el-checkbox>
          <el-checkbox
            v-show="enableShipperConsignNotify"
            v-model="job.shipperLock"
            no="shipperLock"
            style="margin-left: -20px;"
            :disabled="true"
          >{{ $t('SeaExport.ShipperLocked') }}
          </el-checkbox>
          <el-checkbox
            v-model="form.oversea"
            no="8"
            style="margin-left: -20px;"
            :disabled="readonly"
          >{{ $t('SeaExport.BlBeReleased') }}
          </el-checkbox>
          <el-checkbox
            v-model="form.edi"
            no="9"
            style="margin-left: -20px;"
            :disabled="readonly"
          >{{ $t('SeaExport.BlEdi') }}
          </el-checkbox>
          <el-checkbox
            v-model="form.manifestEDI"
            no="10"
            style="margin-left: -20px;"
            :disabled="readonly"
          >{{ $t('SeaExport.ManifestEdi') }}
          </el-checkbox>
          <el-checkbox
            v-model="form.printParam1"
            no="11"
            style="margin-left: -20px;"
            :disabled="readonly"
          >Part of
          </el-checkbox>
          <el-checkbox
            v-model="form.printParam3"
            no="12"
            style="margin-left: -20px;"
            :disabled="readonly"
          >{{
            $t('SeaExport.ShowNumberOfPackagesGrossWeightAndMeasurementAfterCNTRNOSSEALNOS')
          }}
          </el-checkbox>
          <el-checkbox
            v-show="job.barge"
            v-model="form.printParam6"
            no="13"
            style="margin-left: -20px;"
            :disabled="readonly"
            @change="pm.printParam6Change()"
          >{{ $t('SeaExport.PrintBargeVesselAndVoyage') }}
          </el-checkbox>
          <el-checkbox
            v-model="form.showPODAgency"
            no="14"
            style="margin-left: -20px;"
            :disabled="readonly"
          >ShowPODAgency
          </el-checkbox>
          <el-button
            v-show="btnExcelVisible"
            no="15"
            style="margin-right: 10px;"
            type="primary"
            @click="pm.exportToExcel()"
          >{{ $t('SeaExport.ExportToExcel') }}
          </el-button>
        </div>
      </div>
    </div>
    <div style="display: flex">
      <div class="section form-column">
        <el-form
          v-show="!form.showDetail"
          label-width="70px"
          label-position="right"
          style="height:100%"
        >
          <div style="display: flex; align-items: center; white-space: nowrap; min-width: 100%; margin-bottom: 10px;">
            <span class="title" style="flex-shrink: 0;">{{ $t('SeaExport.ConsigneeShipperAndNotifyInfo') }}</span>
            <div style="flex-grow: 1;" />
            <el-button no="formatChange" :disabled="readonly" type="primary" style="flex-shrink: 0;" @click="formatChange(true)">{{ $t('CargoMsg.Cargo_DetailFormat') }} </el-button>
          </div>
          <el-form-item
            class="auto-width"
            :class="variableCss.shipperCode"
          >
            <span slot="label" :class="variableCss.shipperLine">{{ $t('SeaExport.Shipper') }}</span>
            <div style="display: flex;width: 100%">
              <el-input
                v-show="!synchronousShipperCodeAndConsigneeCodeAndNotifyCode"
                ref="shipperCode"
                v-model="form.shipperCode"
                :disabled="readonly || (!readonly && job.shipperLock)"
                no="16"
                style="flex:1"
                :class="importDifferenceField.shipperCode ? 'red-border' : ''"
              />
              <cargo-advance-select
                v-show="synchronousShipperCodeAndConsigneeCodeAndNotifyCode"
                no="17"
                :select-type="selectTypeNames.basic_data_Company"
                :method-params="{ shipper: true, active: true }"
                filterable
                :default-value="form.shipperId||''"
                :disabled="readonly || (!readonly && job.shipperLock)"
                style="flex:1"
                :class="importDifferenceField.shipperId ? 'red-border' : ''"
                @parentCallBack="p=>{pm.shipperAutoCompleteChange(p)}"
              />
              <el-button
                no="18"
                type="primary"
                style="margin-left: 5px"
                :disabled="readonly || (!readonly && job.shipperLock)"
                @click="pm.onClear(1)"
              >{{ $t('SeaExport.Reset') }}
              </el-button>
              <char-count inline :form="form" prefix="shipper" />
            </div>
          </el-form-item>
          <el-form-item
            v-for="count in 7"
            :key="'shipperLine'+count"
            class="auto-width"
            :class="getClass('shipperLine',count)"
          >
            <special-character-tip :texts="specialCharCheck['shipperLine'+count]">
              <cargo-input
                :ref="'shipperLine'+count"
                v-model="form['shipperLine'+count]"
                :no="'shipperLine'+count"
                :placeholder="placeholderSFT(count)"
                :auto-uppercase="notUppercaseShipperConsigneNotify"
                :disabled="readonly || (!readonly && job.shipperLock)"
                :filter-chars="false"
                :use-read-only="true"
                :class="importDifferenceField['shipperLine'+count] ? 'red-border' : ''"
                @dblclick.native="showShipperDialog"
                @change="()=>wrapAddr(form,'shipperLine'+count,count+1 > 6 ? null :'shipperLine'+(count+1),maxChars)"
              />
            </special-character-tip>
          </el-form-item>
          <el-form-item
            class="auto-width"
            :class="variableCss.consigneeCode"
          >
            <span slot="label" :class="variableCss.consigneeLine">{{ $t('SeaExport.Consignee') }}</span>
            <div style="display: flex;width: 100%">
              <el-input
                v-show="!synchronousShipperCodeAndConsigneeCodeAndNotifyCode"
                ref="consigneeCode"
                v-model="form.consigneeCode"
                :disabled="readonly"
                no="19"
                style="flex:1"
                :class="importDifferenceField.consigneeCode ? 'red-border' : ''"
              />
              <cargo-advance-select
                v-show="synchronousShipperCodeAndConsigneeCodeAndNotifyCode"
                :disabled="readonly"
                no="20"
                :select-type="selectTypeNames.basic_data_Company"
                :method-params="{ consignee: true, active: true }"
                filterable
                :default-value="form.consigneeId||''"
                style="flex:1"
                :class="importDifferenceField.consigneeId ? 'red-border' : ''"
                @parentCallBack="p=>{pm.consigneeAutoCompleteChange(p)}"
              />
              <el-button
                no="21"
                type="primary"
                :disabled="readonly"
                style="margin-left: 5px"
                @click="pm.onClear(2)"
              >{{ $t('SeaExport.Reset') }}
              </el-button>
              <char-count inline :form="form" prefix="consignee" />
            </div>
          </el-form-item>
          <el-form-item
            v-for="count in 7"
            :key="'consigneeLine'+count"
            class="auto-width"
            :class="getClass('consigneeLine',count)"
          >
            <special-character-tip :texts="specialCharCheck['consigneeLine'+count]">
              <cargo-input
                :ref="'consigneeLine'+count"
                v-model="form['consigneeLine'+count]"
                :disabled="readonly"
                :no="'consigneeLine'+count"
                :placeholder="placeholderSFT(count)"
                :auto-uppercase="notUppercaseShipperConsigneNotify"
                :filter-chars="false"
                :use-read-only="true"
                :class="importDifferenceField['consigneeLine'+count] ? 'red-border' : ''"
                @dblclick.native="showConsigneeDialog"
                @change="()=>wrapAddr(form,'consigneeLine'+count,count+1 > 6 ? null :'consigneeLine'+(count+1),maxChars)"
              />
            </special-character-tip>
          </el-form-item>
          <el-form-item
            class="auto-width"
            :class="variableCss.notifyCode"
          >
            <span slot="label" :class="variableCss.notifyLine">{{ $t('SeaExport.NotifyParty') }}</span>
            <div>
              <el-input
                v-show="!synchronousShipperCodeAndConsigneeCodeAndNotifyCode"
                ref="notifyCode"
                v-model="form.notifyCode"
                :disabled="readonly"
                :class="importDifferenceField.notifyCode ? 'red-border' : ''"
                no="22"
              />
              <cargo-advance-select
                v-show="synchronousShipperCodeAndConsigneeCodeAndNotifyCode"
                :disabled="readonly"
                no="23"
                :select-type="selectTypeNames.basic_data_Company"
                :method-params="{ notify: true, active: true }"
                filterable
                :default-value="form.notifyId||''"
                :class="importDifferenceField.notifyId ? 'red-border' : ''"
                @parentCallBack="p=>{pm.notifyAutoCompleteChange(p)}"
              />
              <div style="margin-top: 5px">
                <el-button
                  no="24"
                  type="primary"
                  :disabled="readonly"
                  @click="pm.onClear(3)"
                >{{ $t('SeaExport.Reset') }}
                </el-button>
                <el-button
                  no="25"
                  type="primary"
                  :disabled="readonly"
                  style="margin-left: 5px"
                  @click="pm.onCopyConsignee()"
                >{{ $t('SeaExport.CopyTheConsignee') }}
                </el-button>
                <char-count inline :form="form" prefix="notify" />
              </div>
            </div>
          </el-form-item>
          <el-form-item
            v-for="count in 7"
            :key="'notifyLine'+count"
            class="auto-width"
            :class="getClass('notifyLine',count)"
          >
            <special-character-tip :texts="specialCharCheck['notifyLine'+count]">
              <cargo-input
                :ref="'notifyLine'+count"
                v-model="form['notifyLine'+count]"
                :disabled="readonly"
                :no="'notifyLine'+count"
                :placeholder="placeholderSFT(count)"
                :auto-uppercase="notUppercaseShipperConsigneNotify"
                :filter-chars="false"
                :use-read-only="true"
                :class="importDifferenceField['consigneeLine'+count] ? 'red-border' : ''"
                @dblclick.native="showNotifyDialog"
                @change="()=>wrapAddr(form,'notifyLine'+count,count+1 > 6 ? null :'notifyLine'+(count+1),maxChars)"
              />
            </special-character-tip>
          </el-form-item>
          <el-form-item>
            <div style="display: flex;">
              <el-select
                v-model="otherSelectField"
                :disabled="readonly"
                no="26"
                style="flex: 1"
                @change="val=>{pm.otherInfoChangeHandler(val)}"
              >
                <el-option
                  v-for="(item,index) in otherFieldsData"
                  :key="index"
                  :label="item.englishName"
                  :value="item.code"
                />
              </el-select>
              <cargo-input
                v-if="otherSelectField!=='ALSO NOTIFY'"
                v-model="otherCode"
                :disabled="readonly"
                no="27"
                :maxlength="maxChars"
                :auto-uppercase="notUppercaseShipperConsigneNotify"
                style="flex: 1;margin-left: 5px;"
              />
              <cargo-advance-select
                v-if="otherSelectField==='ALSO NOTIFY'"
                :disabled="readonly"
                no="68"
                :allow-create="true"
                :select-type="selectTypeNames.basic_data_Company"
                :method-params="{ notify: true, active: true }"
                tag-name="englishName"
                tag-value="englishName"
                filterable
                style="flex: 1;margin-left: 5px;"
                :default-value="otherCode||''"
                @parentCallBack="p=>{pm.alsoNotifyAutoCompleteChange(p)}"
              />
            </div>
          </el-form-item>
          <div v-show="otherSelectField==='ALSO NOTIFY'" style="margin-left: 20px">
            <cargo-rich-textarea
              v-model="form.alsoNotify"
              :disabled="readonly"
              no="28"
              :text-chars="0"
              wrap-symbol="r"
              auto-half-word
              :auto-uppercase="notUppercaseShipperConsigneNotify"
              style="height: 110px; margin-left: 50px"
              @dblclick.native="showAdvanceTextDialog('ALSO NOTIFY',form.alsoNotify,val=>{form.alsoNotify=val},false,null,notUppercaseShipperConsigneNotify, {
                warningCount: 45,
                maxChar: 0,autoUppercase:notUppercaseShipperConsigneNotify,autoHalfWord:true
              })"
            />
          </div>
          <div v-show="otherSelectField==='DGCONSIGN'" style="margin-left: 20px">
            <el-form-item
              v-for="count in 7"
              :key="'dgconsignLine'+count"
              class="auto-width"
            >
              <cargo-input
                :ref="'dgconsignLine'+count"
                v-model="form['dgconsignLine'+count]"
                :disabled="readonly"
                no="29"
                :auto-uppercase="isUppercase"
                :use-read-only="true"
                @dblclick.native="showDgconsignDialog"
                @change="()=>wrapAddr(form,'dgconsignLine'+count,count+1 > 6 ? null :'dgconsignLine'+(count+1),maxChars)"
              />
            </el-form-item>
          </div>
          <div v-show="otherSelectField==='ELSEINVOICE'" style="margin-left: 20px">
            <el-form-item
              v-for="count in 7"
              :key="'elseInvoiceLine'+count"
              class="auto-width"
            >
              <cargo-input
                :ref="'elseInvoiceLine'+count"
                v-model="form['elseInvoiceLine'+count]"
                :disabled="readonly"
                no="30"
                :auto-uppercase="isUppercase"
                :use-read-only="true"
                @dblclick.native="showElseInvoiceDialog"
                @change="()=>wrapAddr(form,'elseInvoiceLine'+count,count+1 > 6 ? null :'elseInvoiceLine'+(count+1),maxChars)"
              />
            </el-form-item>
          </div>

          <el-form-item
            v-if="job.paymentTermMBL === '3P'"
            class="auto-width"
            style="padding-top: 5px"
          >
            <span slot="label">{{ $t('CargoMsg.Cargo_Payment1') }}</span>
            <div style="display: flex;width: 100%">
              <el-input
                v-model="form.paymentCode"
                :disabled="readonly"
                no="paymentCode"
                style="flex:1"
              />
              <el-button
                no="BringInData"
                type="primary"
                style="margin-left: 5px"
                :disabled="readonly "
                @click="pm.paymentImportData(true)"
              >{{ $t('CargoMsg.Cargo_BringInData') }}
              </el-button>
            </div>
          </el-form-item>
          <el-form-item
            v-for="count in 7"
            v-if="job.paymentTermMBL === '3P'"
            :key="'paymentLine'+count"
            class="auto-width"
          >
            <cargo-input
              :ref="'paymentLine'+count"
              v-model="form['paymentLine'+count]"
              :disabled="readonly"
              :no="'paymentLine'+count"
              :placeholder="placeholderSFT(count)"
              :auto-uppercase="isUppercase"
              :filter-chars="false"
              :use-read-only="true"
              @dblclick.native="showPaymentDialog"
              @change="()=>wrapAddr(form,'paymentLine'+count,count+1 > 6 ? null :'paymentLine'+(count+1),0)"
            />
          </el-form-item>
        </el-form>
        <el-form
          v-show="form.showDetail"
          label-width="70px"
          label-position="right"
          style="height:100%"
        >
          <!--  发货人 -->
          <div style="display: flex; align-items: center; white-space: nowrap; min-width: 100%; margin-bottom: 10px;">
            <span class="title" style="flex-shrink: 0;">{{ $t('SeaExport.ConsigneeShipperAndNotifyInfo') }}</span>
            <div style="flex-grow: 1;" />
            <el-button no="GeneralFormat" :disabled="readonly" type="primary" style="flex-shrink: 0;" @click="formatChange(false)">{{ $t('CargoMsg.Cargo_GeneralFormat') }} </el-button>
          </div>
          <el-form-item
            class="auto-width"
            :class="variableCss.shipperCode"
          >
            <span slot="label" :class="variableCss.shipperLine">{{ $t('SeaExport.Shipper') }}</span>
            <div style="display: flex;width: 100%">
              <el-input
                v-show="!synchronousShipperCodeAndConsigneeCodeAndNotifyCode"
                ref="shipperCode"
                v-model="form.shipperCode"
                :disabled="readonly || (!readonly && job.shipperLock)"
                no="16"
                style="flex:1"
              />
              <cargo-advance-select
                v-show="synchronousShipperCodeAndConsigneeCodeAndNotifyCode"
                no="17"
                :select-type="selectTypeNames.basic_data_Company"
                :method-params="{ shipper: true, active: true }"
                filterable
                :default-value="form.shipperId||''"
                :disabled="readonly || (!readonly && job.shipperLock)"
                style="flex:1"
                @parentCallBack="p=>{pm.shipperAutoCompleteChange(p, true)}"
              />
              <el-button
                no="18"
                type="primary"
                style="margin-left: 5px"
                :disabled="readonly || (!readonly && job.shipperLock)"
                @click="pm.onClear(1, true)"
              >{{ $t('SeaExport.Reset') }}
              </el-button>
            </div>
          </el-form-item>
          <el-form-item
            :label="$t('CargoMsg.Cargo_Name')"
            class="auto-width"
          >
            <cargo-input
              v-model="form.shipperLine1"
              :disabled="readonly"
              no="shipperLine1"
              :filter-chars="false"
              :use-read-only="true"
              @dblclick.native="showShipperDialog"
              @change="()=>wrapAddr(form,'shipperLine1','shipperLine2',maxChars)"
            />
          </el-form-item>
          <el-form-item
            :label="$t('SeaExport.Addr') + '1'"
            class="auto-width"
          >
            <cargo-input
              v-model="form.shipperLine2"
              :disabled="readonly"
              no="shipperLine2"
              :filter-chars="false"
              :use-read-only="true"
              @dblclick.native="showShipperDialog"
              @change="()=>wrapAddr(form,'shipperLine2','shipperLine3',maxChars)"
            />
          </el-form-item>
          <el-form-item
            :label="$t('SeaExport.Addr') + '2'"
            class="auto-width"
          >
            <cargo-input
              v-model="form.shipperLine3"
              :disabled="readonly"
              no="shipperLine3"
              :filter-chars="false"
              :use-read-only="true"
              @dblclick.native="showShipperDialog"
              @change="()=>wrapAddr(form,'shipperLine3','shipperLine4',maxChars)"
            />
          </el-form-item>
          <el-form-item
            :label="$t('CargoMsg.Cargo_Country')"
            style="margin-bottom: -10px"
          >
            <div style="display:flex;">
              <el-input
                v-model="form.shipperCountry"
                no="shipperCountry"
                style="width: 80px"
                :disabled="readonly"
              />
              <el-form-item
                :label="$t('CargoMsg.Cargo_CityP')"
                class="auto-width"
              >
                <el-input
                  v-model="form.shipperCity"
                  no="shipperCity"
                  style="width: 80px"
                  :disabled="readonly"
                />
              </el-form-item>
            </div>
          </el-form-item>
          <el-form-item
            :label="$t('CargoMsg.Cargo_Province1')"
          >
            <div style="display:flex;">
              <el-input
                v-model="form.shipperProvince"
                no="shipperProvince"
                style="width: 80px"
                :disabled="readonly"
              />
              <el-form-item
                :label="$t('CargoMsg.Cargo_PostalCode')"
                class="auto-width"
              >
                <el-input
                  v-model="form.shipperZipCode"
                  no="shipperZipCode"
                  style="width: 80px"
                  :disabled="readonly"
                />
              </el-form-item>
            </div>
          </el-form-item>
          <el-form-item
            :label="$t('CargoMsg.Cargo_Tel')"
          >
            <div style="display:flex;">
              <el-input
                v-model="form.shipperMobile"
                no="shipperMobile"
                style="width: 80px"
                :disabled="readonly"
              />
              <el-form-item
                :label="$t('CargoMsg.Cargo_email')"
                class="auto-width"
              >
                <el-input
                  v-model="form.shipperEmail"
                  no="shipperEmail"
                  style="width: 80px"
                  :disabled="readonly"
                />
              </el-form-item>
            </div>
          </el-form-item>
          <el-form-item
            :label="$t('CargoMsg.Cargo_Contact')"
            class="auto-width"
          >
            <div style="display:flex;padding-bottom: 5px">
              <el-input
                v-model="form.shipperContact"
                no="shipperContact"
                style="width: 80px"
                :disabled="readonly"
              />
              <el-form-item
                :label="'Fax'"
              >
                <el-input
                  v-model="form.shipperFax"
                  no="shipperFax"
                  style="width: 80px"
                  :disabled="readonly"
                />
              </el-form-item>
            </div>
          </el-form-item>

          <!-- 收货人 -->
          <el-form-item
            class="auto-width"
            :class="variableCss.consigneeCode"
          >
            <span slot="label" :class="variableCss.consigneeLine">{{ $t('SeaExport.Consignee') }}</span>
            <div style="display: flex;width: 100%">
              <el-input
                v-show="!synchronousShipperCodeAndConsigneeCodeAndNotifyCode"
                ref="consigneeCode"
                v-model="form.consigneeCode"
                :disabled="readonly"
                no="19"
                style="flex:1"
              />
              <cargo-advance-select
                v-show="synchronousShipperCodeAndConsigneeCodeAndNotifyCode"
                :disabled="readonly"
                no="20"
                :select-type="selectTypeNames.basic_data_Company"
                :method-params="{ consignee: true, active: true }"
                filterable
                :default-value="form.consigneeId||''"
                style="flex:1"
                @parentCallBack="p=>{pm.consigneeAutoCompleteChange(p, true)}"
              />
              <el-button
                no="21"
                type="primary"
                :disabled="readonly"
                style="margin-left: 5px"
                @click="pm.onClear(2, true)"
              >{{ $t('SeaExport.Reset') }}
              </el-button>
            </div>
          </el-form-item>
          <el-form-item
            :label="$t('CargoMsg.Cargo_Name')"
            class="auto-width"
          >
            <cargo-input
              v-model="form.consigneeLine1"
              :disabled="readonly"
              no="consigneeLine1"
              :filter-chars="false"
              :use-read-only="true"
              @dblclick.native="showConsigneeDialog"
              @change="()=>wrapAddr(form,'consigneeLine1','consigneeLine2',maxChars)"
            />
          </el-form-item>
          <el-form-item
            :label="$t('SeaExport.Addr') + '1'"
            class="auto-width"
          >
            <cargo-input
              v-model="form.consigneeLine2"
              :disabled="readonly"
              no="consigneeLine2"
              :filter-chars="false"
              :use-read-only="true"
              @dblclick.native="showConsigneeDialog"
              @change="()=>wrapAddr(form,'consigneeLine2','consigneeLine3',maxChars)"
            />
          </el-form-item>
          <el-form-item
            :label="$t('SeaExport.Addr') + '2'"
            class="auto-width"
          >
            <cargo-input
              v-model="form.consigneeLine3"
              :disabled="readonly"
              no="consigneeLine3"
              :filter-chars="false"
              :use-read-only="true"
              @dblclick.native="showConsigneeDialog"
              @change="()=>wrapAddr(form,'consigneeLine3','consigneeLine4',maxChars)"
            />
          </el-form-item>
          <el-form-item
            :label="$t('CargoMsg.Cargo_Country')"
            class="auto-width"
          >
            <div style="display:flex;">
              <el-input
                v-model="form.consigneeCountry"
                style="width: 80px"
                no="consigneeCountry"
                :disabled="readonly"
              />
              <el-form-item
                :label="$t('CargoMsg.Cargo_CityP')"
                class="auto-width"
              >
                <el-input
                  v-model="form.consigneeCity"
                  no="consigneeCity"
                  style="width: 80px"
                  :disabled="readonly"
                />
              </el-form-item>
            </div>
          </el-form-item>
          <el-form-item
            :label="$t('CargoMsg.Cargo_Province1')"
            class="auto-width"
          >
            <div style="display:flex;">
              <el-input
                v-model="form.consigneeProvince"
                no="consigneeProvince"
                style="width: 80px"
                :disabled="readonly"
              />
              <el-form-item
                :label="$t('CargoMsg.Cargo_PostalCode')"
                class="auto-width"
              >
                <el-input
                  v-model="form.consigneeZipCode"
                  no="consigneeZipCode"
                  style="width: 80px"
                  :disabled="readonly"
                />
              </el-form-item>
            </div>
          </el-form-item>
          <el-form-item
            :label="$t('CargoMsg.Cargo_Tel')"
          >
            <div style="display:flex;">
              <el-input
                v-model="form.consigneeMobile"
                no="consigneeMobile"
                style="width: 80px"
                :disabled="readonly"
              />
              <el-form-item
                :label="$t('CargoMsg.Cargo_email')"
                class="auto-width"
              >
                <el-input
                  v-model="form.consigneeEmail"
                  no="consigneeEmail"
                  style="width: 80px"
                  :disabled="readonly"
                />
              </el-form-item>
            </div>
          </el-form-item>
          <el-form-item
            :label="$t('CargoMsg.Cargo_Contact')"
            class="auto-width"
          >
            <div style="display:flex;padding-bottom: 5px">
              <el-input
                v-model="form.consigneeContact"
                no="consigneeContact"
                style="width: 80px"
                :disabled="readonly"
              />
              <el-form-item
                :label="'Fax'"
              >
                <el-input
                  v-model="form.consigneeFax"
                  no="consigneeFax"
                  style="width: 80px"
                  :disabled="readonly"
                />
              </el-form-item>
            </div>
          </el-form-item>
          <!-- 通知人 -->
          <el-form-item
            class="auto-width"
            :class="variableCss.notifyCode"
          >
            <span slot="label" :class="variableCss.notifyLine">{{ $t('SeaExport.NotifyParty') }}</span>
            <div>
              <el-input
                v-show="!synchronousShipperCodeAndConsigneeCodeAndNotifyCode"
                ref="notifyCode"
                v-model="form.notifyCode"
                :disabled="readonly"
                no="22"
              />
              <cargo-advance-select
                v-show="synchronousShipperCodeAndConsigneeCodeAndNotifyCode"
                :disabled="readonly"
                no="23"
                :select-type="selectTypeNames.basic_data_Company"
                :method-params="{ notify: true, active: true }"
                filterable
                :default-value="form.notifyId||''"
                @parentCallBack="p=>{pm.notifyAutoCompleteChange(p, true)}"
              />
              <div style="margin-top: 5px">
                <el-button
                  no="24"
                  type="primary"
                  :disabled="readonly"
                  @click="pm.onClear(3, true)"
                >{{ $t('SeaExport.Reset') }}
                </el-button>
                <el-button
                  no="25"
                  type="primary"
                  :disabled="readonly"
                  style="margin-left: 5px"
                  @click="pm.onCopyConsignee(true)"
                >{{ $t('SeaExport.CopyTheConsignee') }}
                </el-button>
              </div>
            </div>
          </el-form-item>
          <el-form-item
            :label="$t('CargoMsg.Cargo_Name')"
            class="auto-width"
          >
            <cargo-input
              v-model="form.notifyLine1"
              no="notifyLine2"
              :disabled="readonly"
              :filter-chars="false"
              :use-read-only="true"
              @dblclick.native="showNotifyDialog"
              @change="()=>wrapAddr(form,'notifyLine1','notifyLine2',maxChars)"
            />
          </el-form-item>
          <el-form-item
            :label="$t('SeaExport.Addr') + '1'"
            class="auto-width"
          >
            <cargo-input
              v-model="form.notifyLine2"
              no="notifyLine2"
              :disabled="readonly"
              :filter-chars="false"
              :use-read-only="true"
              @dblclick.native="showNotifyDialog"
              @change="()=>wrapAddr(form,'notifyLine2','notifyLine3',maxChars)"
            />
          </el-form-item>
          <el-form-item
            :label="$t('SeaExport.Addr') + '2'"
            class="auto-width"
          >
            <cargo-input
              v-model="form.notifyLine3"
              no="notifyLine3"
              :disabled="readonly"
              :filter-chars="false"
              :use-read-only="true"
              @dblclick.native="showNotifyDialog"
              @change="()=>wrapAddr(form,'notifyLine3','notifyLine4',maxChars)"
            />
          </el-form-item>
          <el-form-item
            :label="$t('CargoMsg.Cargo_Country')"
            class="auto-width"
          >
            <div style="display:flex;">
              <el-input
                v-model="form.notifyCountry"
                no="notifyCountry"
                style="width: 80px"
                :disabled="readonly"
              />
              <el-form-item
                :label="$t('CargoMsg.Cargo_CityP')"
                class="auto-width"
              >
                <el-input
                  v-model="form.notifyCity"
                  no="notifyCity"
                  style="width: 80px"
                  :disabled="readonly"
                />
              </el-form-item>
            </div>
          </el-form-item>
          <el-form-item
            :label="$t('CargoMsg.Cargo_Province1')"
            class="auto-width"
          >
            <div style="display:flex;">
              <el-input
                v-model="form.notifyProvince"
                no="notifyProvince"
                style="width: 80px"
                :disabled="readonly"
              />
              <el-form-item
                :label="$t('CargoMsg.Cargo_PostalCode')"
                class="auto-width"
              >
                <el-input
                  v-model="form.notifyZipCode"
                  no="notifyZipCode"
                  style="width: 80px"
                  :disabled="readonly"
                />
              </el-form-item>
            </div>
          </el-form-item>
          <el-form-item
            :label="$t('CargoMsg.Cargo_Tel')"
          >
            <div style="display:flex;">
              <el-input
                v-model="form.notifyMobile"
                no="notifyMobile"
                style="width: 80px"
                :disabled="readonly"
              />
              <el-form-item
                :label="$t('CargoMsg.Cargo_email')"
                class="auto-width"
              >
                <el-input
                  v-model="form.notifyEmail"
                  no="notifyEmail"
                  style="width: 80px"
                  :disabled="readonly"
                />
              </el-form-item>
            </div>
          </el-form-item>
          <el-form-item
            :label="$t('CargoMsg.Cargo_Contact')"
            class="auto-width"
          >
            <div style="display:flex;padding-bottom: 5px">
              <el-input
                v-model="form.notifyContact"
                no="notifyContact"
                style="width: 80px"
                :disabled="readonly"
              />
              <el-form-item
                :label="'Fax'"
              >
                <el-input
                  v-model="form.notifyFax"
                  no="notifyFax"
                  style="width: 80px"
                  :disabled="readonly"
                />
              </el-form-item>
            </div>
          </el-form-item>
          <!-- ALSO NOTIFY -->
          <el-form-item>
            <div style="display: flex;">
              <el-select
                v-model="otherSelectField"
                no="otherSelectField"
                :disabled="readonly"
                style="flex: 1"
                @change="val=>{pm.otherInfoChangeHandler(val)}"
              >
                <el-option
                  v-for="(item,index) in otherFieldsData"
                  :key="index"
                  :label="item.englishName"
                  :value="item.code"
                />
              </el-select>
              <cargo-input
                v-if="otherSelectField!=='ALSO NOTIFY'"
                v-model="otherCode"
                :disabled="readonly"
                no="maxChars"
                :maxlength="maxChars"
                :auto-uppercase="notUppercaseShipperConsigneNotify"
                style="flex: 1;margin-left: 5px;"
              />
              <cargo-advance-select
                v-if="otherSelectField==='ALSO NOTIFY'"
                :disabled="readonly"
                no="otherCode"
                :allow-create="true"
                :select-type="selectTypeNames.basic_data_Company"
                :method-params="{ notify: true, active: true }"
                tag-name="englishName"
                tag-value="englishName"
                filterable
                style="flex: 1;margin-left: 5px;"
                :default-value="otherCode||''"
                @parentCallBack="p=>{pm.alsoNotifyAutoCompleteChange(p)}"
              />
            </div>
          </el-form-item>
          <el-form-item
            :label="$t('CargoMsg.Cargo_Name')"
            class="auto-width"
          >
            <cargo-input
              v-model="alsoNotify.line1"
              no="alsoNotifyLine1"
              :disabled="readonly"
              :filter-chars="false"
              :use-read-only="true"
              :auto-uppercase="true"
              @dblclick.native="showAdvanceTextDialog('ALSO NOTIFY',form.alsoNotify,val=>{ summarizeAlso(val) },false,null,true, {
                warningCount: 45,
                maxChar: 0,autoUppercase:true,autoHalfWord:true
              })"
              @change="alsoChange"
            />
          </el-form-item>
          <el-form-item
            :label="$t('SeaExport.Addr') + '1'"
            class="auto-width"
          >
            <cargo-input
              v-model="alsoNotify.line2"
              no="alsoNotifyLine2"
              :disabled="readonly"
              :filter-chars="false"
              :use-read-only="true"
              :auto-uppercase="true"
              @dblclick.native="showAdvanceTextDialog('ALSO NOTIFY',form.alsoNotify,val=>{ summarizeAlso(val) },false,null,true, {
                warningCount: 45,
                maxChar: 0,autoUppercase:true,autoHalfWord:true
              })"
              @change="alsoChange"
            />
          </el-form-item>
          <el-form-item
            :label="$t('SeaExport.Addr') + '2'"
            class="auto-width"
          >
            <cargo-input
              v-model="alsoNotify.line3"
              no="alsoNotifyLine3"
              :disabled="readonly"
              :filter-chars="false"
              :use-read-only="true"
              :auto-uppercase="true"
              @dblclick.native="showAdvanceTextDialog('ALSO NOTIFY',form.alsoNotify,val=>{ summarizeAlso(val) },false,null,true, {
                warningCount: 45,
                maxChar: 0,autoUppercase:true,autoHalfWord:true
              })"
              @change="alsoChange"
            />
          </el-form-item>
          <el-form-item
            :label="$t('CargoMsg.Cargo_Country')"
            class="auto-width"
          >
            <div style="display:flex;">
              <el-input
                v-model="form.alsoNotifyCountry"
                no="alsoNotifyCountry"
                style="width: 80px"
                :disabled="readonly"
              />
              <el-form-item
                :label="$t('CargoMsg.Cargo_CityP')"
                class="auto-width"
              >
                <el-input
                  v-model="form.alsoNotifyCity"
                  no="alsoNotifyCity"
                  style="width: 80px"
                  :disabled="readonly"
                />
              </el-form-item>
            </div>
          </el-form-item>
          <el-form-item
            :label="$t('CargoMsg.Cargo_Province1')"
            class="auto-width"
          >
            <div style="display:flex;">
              <el-input
                v-model="form.alsoNotifyProvince"
                no="alsoNotifyProvince"
                style="width: 80px"
                :disabled="readonly"
              />
              <el-form-item
                :label="$t('CargoMsg.Cargo_PostalCode')"
                class="auto-width"
              >
                <el-input
                  v-model="form.alsoNotifyZipCode"
                  no="alsoNotifyZipCode"
                  style="width: 80px"
                  :disabled="readonly"
                />
              </el-form-item>
            </div>
          </el-form-item>
          <el-form-item
            :label="$t('CargoMsg.Cargo_Tel')"
          >
            <div style="display:flex;">
              <el-input
                v-model="form.alsoNotifyMobile"
                no="alsoNotifyMobile"
                style="width: 80px"
                :disabled="readonly"
              />
              <el-form-item
                :label="$t('CargoMsg.Cargo_email')"
                class="auto-width"
              >
                <el-input
                  v-model="form.alsoNotifyEmail"
                  no="alsoNotifyEmail"
                  style="width: 80px"
                  :disabled="readonly"
                />
              </el-form-item>
            </div>
          </el-form-item>
          <el-form-item
            :label="$t('CargoMsg.Cargo_Contact')"
            class="auto-width"
          >
            <div style="display:flex;padding-bottom: 5px">
              <el-input
                v-model="form.alsoNotifyContact"
                no="alsoNotifyContact"
                style="width: 80px"
                :disabled="readonly"
              />
              <el-form-item
                :label="'Fax'"
              >
                <el-input
                  v-model="form.alsoNotifyFax"
                  no="alsoNotifyFax"
                  style="width: 80px"
                  :disabled="readonly"
                />
              </el-form-item>
            </div>
          </el-form-item>
          <!--          付款方-->
          <div v-if="job.paymentTermMBL === '3P'">
            <el-form-item
              class="auto-width"
            >
              <span slot="label">{{ $t('CargoMsg.Cargo_Payment1') }}</span>
              <div style="display: flex;width: 100%">
                <el-input
                  v-model="form.paymentCode"
                  no="paymentCode"
                  :disabled="readonly"
                  style="flex:1"
                />
                <el-button
                  no="BringInData"
                  type="primary"
                  style="margin-left: 5px"
                  :disabled="readonly"
                  @click="pm.paymentImportData(false)"
                >{{ $t('CargoMsg.Cargo_BringInData') }}
                </el-button>
              </div>
            </el-form-item>
            <el-form-item
              :label="$t('CargoMsg.Cargo_Name')"
              class="auto-width"
            >
              <cargo-input
                v-model="form.paymentLine1"
                no="paymentLine1"
                :disabled="readonly"
                :filter-chars="false"
                :use-read-only="true"
                @dblclick.native="showPaymentDialog"
                @change="()=>wrapAddr(form,'paymentLine1','paymentLine2',0)"
              />
            </el-form-item>
            <el-form-item
              :label="$t('SeaExport.Addr') + '1'"
              class="auto-width"
            >
              <cargo-input
                v-model="form.paymentLine2"
                no="paymentLine2"
                :disabled="readonly"
                :filter-chars="false"
                :use-read-only="true"
                @dblclick.native="showPaymentDialog"
                @change="()=>wrapAddr(form,'paymentLine2','paymentLine3',0)"
              />
            </el-form-item>
            <el-form-item
              :label="$t('SeaExport.Addr') + '2'"
              class="auto-width"
            >
              <cargo-input
                v-model="form.paymentLine3"
                no="paymentLine3"
                :disabled="readonly"
                :filter-chars="false"
                :use-read-only="true"
                @dblclick.native="showPaymentDialog"
                @change="()=>wrapAddr(form,'paymentLine1','paymentLine2',0)"
              />
            </el-form-item>
            <el-form-item
              :label="$t('CargoMsg.Cargo_Country')"
              class="auto-width"
            >
              <div style="display:flex;">
                <el-input
                  v-model="form.paymentCountry"
                  no="paymentCountry"
                  style="width: 80px"
                  :disabled="readonly"
                />
                <el-form-item
                  :label="$t('CargoMsg.Cargo_CityP')"
                  class="auto-width"
                >
                  <el-input
                    v-model="form.paymentCity"
                    no="paymentCity"
                    style="width: 80px"
                    :disabled="readonly"
                  />
                </el-form-item>
              </div>
            </el-form-item>
            <el-form-item
              :label="$t('CargoMsg.Cargo_Province1')"
              class="auto-width"
            >
              <div style="display:flex;">
                <el-input
                  v-model="form.paymentProvince"
                  no="paymentProvince"
                  style="width: 80px"
                  :disabled="readonly"
                />
                <el-form-item
                  :label="$t('CargoMsg.Cargo_PostalCode')"
                  class="auto-width"
                >
                  <el-input
                    v-model="form.paymentPostalCode"
                    no="paymentPostalCode"
                    style="width: 80px"
                    :disabled="readonly"
                  />
                </el-form-item>
              </div>
            </el-form-item>
            <el-form-item
              :label="$t('CargoMsg.Cargo_Tel')"
            >
              <div style="display:flex;">
                <el-input
                  v-model="form.paymentPhone"
                  no="paymentPhone"
                  style="width: 80px"
                  :disabled="readonly"
                />
                <el-form-item
                  :label="$t('CargoMsg.Cargo_email')"
                  class="auto-width"
                >
                  <el-input
                    v-model="form.paymentEmail"
                    no="paymentEmail"
                    style="width: 80px"
                    :disabled="readonly"
                  />
                </el-form-item>
              </div>
            </el-form-item>
            <el-form-item
              :label="$t('CargoMsg.Cargo_Contact')"
              class="auto-width"
            >
              <div style="display:flex;padding-bottom: 5px">
                <el-input
                  v-model="form.paymentContact"
                  no="paymentContact"
                  style="width: 80px"
                  :disabled="readonly"
                />
                <el-form-item
                  :label="'Fax'"
                >
                  <el-input
                    v-model="form.paymentFax"
                    no="paymentFax"
                    style="width: 80px"
                    :disabled="readonly"
                  />
                </el-form-item>
              </div>
            </el-form-item>
          </div>

        </el-form>
      </div>
      <div class="section form-column" style="width: 345px">
        <el-form
          :disabled="readonly"
          label-width="125px"
          label-position="right"
          style="height:100%"
        >
          <span class="title">{{ $t('SeaExport.CargoInfo') }}</span>
          <el-form-item style="display: flex; justify-content: flex-end;">
            <el-button type="primary" :disabled="synContainerInfoDisable" @click="syncContainerInfoDialogHandle">{{ $t('SeaExport.SyncContainerInfoTotal') }}</el-button>
          </el-form-item>
          <el-form-item
            :label="$t('SeaExport.NumberOfPackagesOnBl')"
            :class="variableCss.quantity"
          >
            <auto-number-input
              v-model="form.quantity"
              no="31"
              :precision="0"
              :min="0"
              :disabled="!isJydEditJobFields"
              :class="importDifferenceField.quantity ? 'red-border' : ''"
              @change="pm.quantityChange()"
            />
          </el-form-item>
          <el-form-item
            :label="$t('SeaExport.Package')"
            :class="variableCss.packing"
          >
            <cargo-packing-select
              no="32"
              :default-value="form.packing"
              :class="importDifferenceField.packing ? 'red-border' : ''"
              @change="p => {pm.packingChange(p)}"
            />
            <!-- <cargo-advance-select
              :select-type="selectTypeNames.basic_data_Packing"
              filterable
              :default-value="form.packing"
              style="width:100%;"
              @parentCallBack="p=>{pm.packingChange(p)}"
            /> -->
          </el-form-item>
          <el-form-item
            :label="$t('SeaExport.PackageDisplayName')"
          >
            <el-input v-model="form.packingName" :class="importDifferenceField.packingName ? 'red-border' : ''" no="33" />
          </el-form-item>
          <el-form-item
            :label="$t('SeaExport.Pieces2')"
            :class="variableCss.insideQuantity"
          >
            <auto-number-input
              v-model="form.insideQuantity"
              no="34"
              :precision="0"
              :min="0"
              :class="importDifferenceField.insideQuantity ? 'red-border' : ''"
            />
          </el-form-item>
          <el-form-item
            :label="$t('SeaExport.PiecesType2')"
            :class="variableCss.insidePacking"
          >
            <!-- <cargo-advance-select
              :select-type="selectTypeNames.basic_data_Packing"
              filterable
              :default-value="form.insidePacking"
              style="width:100%;"
              @parentCallBack="p=>{form.insidePacking=p.value}"
            /> -->
            <cargo-packing-select
              no="35"
              :default-value="form.insidePacking"
              :class="importDifferenceField.insidePacking ? 'red-border' : ''"
              @change="p => {form.insidePacking=p.value}"
            />
          </el-form-item>
          <el-form-item
            :label="$t('SeaExport.Weight')"
            :class="variableCss.weight"
          >
            <div class="form-item-input" :class="readonly ? 'input-disabled': importDifferenceField.weight ? 'red-border' : ''">
              <el-input-number
                v-model="form.weight"
                no="36"
                :precision="3"
                :min="0"
                :controls="false"
                :disabled="!isJydEditJobFields"
                style="flex:1"
                @change="p=>{CargoDocUtil.changeBillOfLadingSynJob(job, form, true);pm.calculateChargeWeight();}"
              />
              <span>KGS</span>
            </div>
          </el-form-item>
          <el-form-item
            :label="$t('SeaExport.Cubage')"
            :class="variableCss.cubage"
          >
            <div class="form-item-input" :class="readonly ? 'input-disabled': importDifferenceField.cubage ? 'red-border' : ''">
              <el-input-number
                v-model="form.cubage"
                no="37"
                :precision="3"
                :min="0"
                :controls="false"
                :disabled="!isJydEditJobFields"
                style="flex:1"
                @change="p=>{CargoDocUtil.changeBillOfLadingSynJob(job, form, true);pm.calculateChargeWeight();}"
              />
              <span>CBM</span>
            </div>
          </el-form-item>
          <el-form-item
            :label="$t('SeaExport.ChargedWeightRT')"
          >
            <div class="form-item-input" :class="readonly ? 'input-disabled': importDifferenceField.chargeWeight ? 'red-border' : ''">
              <el-input-number
                v-model="form.chargeWeight"
                no="38"
                :precision="3"
                :min="0"
                :controls="false"
                style="flex: 1"
                @change="CargoDocUtil.changeBillOfLadingSynJob(job, form, false)"
              />
              <span>M/T</span>
            </div>
          </el-form-item>
          <el-form-item
            v-if="isZh"
            class="auto-width"
            :class="variableCss.cargoEnglishName"
          >
            <div style="display: flex;justify-content: flex-end">
              <div>
                <el-button
                  no="39"
                  type="primary"
                  @click="pm.getHBLInfo('EName')"
                >{{ $t('SeaExport.CopyEnglishDescriptionOfGoodsFromHBL') }}
                </el-button>
                <el-button
                  v-show="masterFlag"
                  no="40"
                  type="primary"
                  style="margin-top: 5px"
                  @click="pm.getSlavesHBLEnglishName()"
                >{{ $t('SeaExport.CopyEnglishDescriptionOfGoodsFromReceipt') }}
                </el-button>
              </div>
            </div>
          </el-form-item>
          <template v-if="!isZh">
            <el-form-item
              class="auto-width"
              :class="variableCss.cargoEnglishName"
            >
              <el-button
                no="41"
                type="primary"
                @click="pm.getHBLInfo('EName')"
              >{{ $t('SeaExport.CopyEnglishDescriptionOfGoodsFromHBL') }}
              </el-button>
            </el-form-item>
            <el-form-item
              v-show="masterFlag"
              class="auto-width"
              :class="variableCss.cargoEnglishName"
            >
              <el-button
                no="42"
                type="primary"
                @click="pm.getSlavesHBLEnglishName()"
              >{{ $t('SeaExport.CopyEnglishDescriptionOfGoodsFromReceipt') }}
              </el-button>
            </el-form-item>
          </template>
          <el-form-item
            class="auto-width"
            :label="$t('SeaExport.EnglishDescriptionOfGoods')"
            :class="variableCss.cargoEnglishName"
          >
            <special-character-tip :texts="specialCharCheck.cargoEnglishName">
              <cargo-rich-textarea
                ref="cargoTextarea1"
                v-model="form.cargoEnglishName"
                no="43"
                :show-count="true"
                :text-chars="englishNameMaxChars"
                :warning-count="englishNameWarningCount"
                wrap-symbol="r"
                :disabled="!isEdit"
                :auto-uppercase="isUppercaseByConfig"
                auto-half-word
                style="height: 110px"
                :class="importDifferenceField.cargoEnglishName ? 'red-border' : ''"
                @change="pm.cargoEnglishNameBlurHandler()"
                @dblclick.native="showAdvanceTextDialog($t('SeaExport.EnglishDescriptionOfGoods'),form.cargoEnglishName,val=>{form.cargoEnglishName=val},false,null,isUppercaseByConfig , {
                  warningCount: englishNameWarningCount,
                  maxChar: englishNameMaxChars,autoUppercase:isUppercaseByConfig,autoHalfWord:true
                })"
              />
            </special-character-tip>
          </el-form-item>
          <el-form-item
            v-if="isZh"
            class="auto-width"
            :class="variableCss.mark"
          >
            <div style="display: flex;justify-content: flex-end">
              <div>
                <el-button
                  no="44"
                  type="primary"
                  @click="pm.getHBLInfo('mark')"
                >{{ $t('SeaExport.CopyMarksFromHbl') }}
                </el-button>
                <el-button
                  v-show="masterFlag"
                  no="45"
                  type="primary"
                  style="margin-top: 5px"
                  @click="pm.getSlavesHBLMark()"
                >{{ $t('SeaExport.CopyMarksFromReceipt') }}
                </el-button>
              </div>
            </div>

          </el-form-item>
          <template v-if="!isZh">
            <el-form-item
              class="auto-width"
              :class="variableCss.mark"
            >
              <el-button
                no="46"
                type="primary"
                @click="pm.getHBLInfo('mark')"
              >{{ $t('SeaExport.CopyMarksFromHbl') }}
              </el-button>
            </el-form-item>
            <el-form-item
              class="auto-width"
              :class="variableCss.mark"
            >
              <el-button
                v-show="masterFlag"
                no="47"
                type="primary"
                @click="pm.getSlavesHBLMark()"
              >{{ $t('SeaExport.CopyMarksFromReceipt') }}
              </el-button>
            </el-form-item>
          </template>
          <el-form-item
            class="auto-width"
            :class="variableCss.mark"
            :label="$t('SeaExport.Marks')"
          >
            <special-character-tip :texts="specialCharCheck.mark">
              <cargo-rich-textarea
                ref="cargoTextarea2"
                v-model="form.mark"
                no="48"
                :show-count="true"
                :text-chars="markMaxChars"
                :warning-count="markWarningCount"
                wrap-symbol="r"
                :disabled="!isEdit"
                :auto-uppercase="isUppercaseByConfig"
                auto-half-word
                style="height: 110px"
                :class="importDifferenceField.mark ? 'red-border' : ''"
                @change="pm.markBlurHandler()"
                @dblclick.native="showAdvanceTextDialog($t('SeaExport.Marks'),form.mark,val=>{form.mark=val},false,null,isUppercaseByConfig , {
                  warningCount: markWarningCount,
                  maxChar: markMaxChars,autoUppercase:isUppercaseByConfig,autoHalfWord:true
                })"
              />
            </special-character-tip>
          </el-form-item>
          <el-form-item :label="$t('SeaExport.HsCode')">
            <special-character-tip :texts="specialCharCheck.hsCode">
              <el-input
                v-if="syncMblHsCodeEdit"
                v-model="form.hsCode"
                no="49"
                type="textarea"
                :rows="5"
                style="width: 100%"
                :class="importDifferenceField.hsCode ? 'red-border' : ''"
                @dblclick.native="showAdvanceTextDialog($t('SeaExport.HsCode'),form.hsCode,val=>{form.hsCode = val})"
              />
              <el-input
                v-else
                v-model="job.hsCode"
                no="49"
                type="textarea"
                :rows="5"
                style="width: 100%"
                :class="importDifferenceField.hsCode ? 'red-border' : ''"
                @input="val=>{hsCodeChangeHandle(val)}"
                @dblclick.native="showAdvanceTextDialog($t('SeaExport.HsCode'),job.hsCode,val=>{hsCodeChangeHandle(val)})"
              />
            </special-character-tip>
          </el-form-item>
          <el-form-item :label="$t('SeaExport.CapitalizedNumbersOfPackages')" class="auto-width">
            <el-input
              v-model="form.quantitySum"
              :class="importDifferenceField.quantitySum ? 'red-border' : ''"
              :disabled="true"
            />
          </el-form-item>
          <el-form-item label="CUS CODE">
            <el-input v-model="form.cusCode" :class="importDifferenceField.cusCode ? 'red-border' : ''" no="cusCode" />
          </el-form-item>
          <el-form-item label="NCM NO">
            <el-input v-model="form.ncmNo" :class="importDifferenceField.ncmNo ? 'red-border' : ''" no="ncmNo" />
          </el-form-item>
        </el-form>
      </div>
      <div class="section form-column">
        <el-form
          label-width="100px"
          label-position="right"
          style="height:100%"
        >
          <span class="title">{{ $t('SeaExport.TransportInfo') }}</span>
          <el-form-item label="MB/L NO.">
            <el-input v-model="job.mbl" no="50" :class="job.mbl==='CANCELLED'?'mbl-red':''" :disabled="readonly" />
          </el-form-item>
          <el-form-item label="SO NO." :class="variableCss.soNoTitle">
            <so-no-input v-model="job.soNo" :disabled="true" :class="variableCss.soNo" />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.MBLBillOfLadingNum')" class="custom">
            <el-input v-model="form.serialNo" :class="importDifferenceField.serialNo ? 'red-border' : ''" no="51" :disabled="readonly" />
          </el-form-item>
          <el-form-item v-if="isHZ" :label="$t('SeaExport.VesselAndVoyage')">
            <el-input v-model="form.vesselVoyage" :class="importDifferenceField.vesselVoyage ? 'red-border' : ''" no="82" :disabled="readonly" />
          </el-form-item>
          <el-form-item v-else :label="$t('SeaExport.VesselAndVoyage')" :class="variableCss.txtFirstVesselVoyageTitle">
            <el-input
              :disabled="true"
              :value="txtFirstVesselVoyage"
              :class="importDifferenceField.vesselVoyage ? variableCss.txtFirstVesselVoyage + ' red-border' : variableCss.txtFirstVesselVoyage"
            />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.DateOfDeparture')">
            <el-input
              :value="sailingDate"
              :disabled="true"
            />
          </el-form-item>
          <el-form-item
            :label="$t('SeaExport.PlaceOfReceiptOnBl')"
            :class="variableCss.dispatchingPlace"
          >
            <cargo-advance-select
              :disabled="true"
              :select-type="selectTypeNames.basic_data_Seaport"
              filterable
              :default-value="form.dispatchingPlaceCode||''"
              tag-name="englishName"
              :class="importDifferenceField.dispatchingPlaceCode ? 'red-border' : ''"
              @parentCallBack="p=>{pm.portChange(p, 'dispatchingPlace')}"
            />
            <special-character-tip :texts="specialCharCheck.dispatchingPlace">
              <el-input v-model="form.dispatchingPlace" :filter-chars="false" :class="importDifferenceField.dispatchingPlace ? 'red-border' : ''" no="52" :disabled="readonly" />
            </special-character-tip>
          </el-form-item>
          <el-form-item
            :label="$t('SeaExport.PortOfLoadingOnBl')"
            :class="variableCss.loadingPort"
          >
            <cargo-advance-select
              :disabled="true"
              :select-type="selectTypeNames.basic_data_Seaport"
              filterable
              :default-value="form.loadingPortCode||''"
              tag-name="englishName"
              no="loadingPortCode"
              :class="importDifferenceField.loadingPortCode ? 'red-border' : ''"
              @parentCallBack="p=>{pm.portChange(p, 'loadingPort')}"
            />
            <special-character-tip :texts="specialCharCheck.loadingPort">
              <el-input v-model="form.loadingPort" :filter-chars="false" :class="importDifferenceField.loadingPort ? 'red-border' : ''" no="53" :disabled="readonly" />
            </special-character-tip>
          </el-form-item>
          <el-form-item
            :label="$t('SeaExport.PortOfDischargeOnBl')"
            :class="variableCss.dischargingPort"
          >
            <cargo-advance-select
              :disabled="true"
              :select-type="selectTypeNames.basic_data_Seaport"
              filterable
              :default-value="form.dischargingPortCode||''"
              tag-name="englishName"
              no="dischargingPortCode"
              :class="importDifferenceField.dischargingPortCode ? 'red-border' : ''"
              @parentCallBack="p=>{pm.portChange(p, 'dischargingPort')}"
            />
            <special-character-tip :texts="specialCharCheck.dischargingPort">
              <el-input v-model="form.dischargingPort" :filter-chars="false" :class="importDifferenceField.dischargingPort ? 'red-border' : ''" no="54" :disabled="readonly" />
            </special-character-tip>
          </el-form-item>
          <el-form-item
            :label="$t('SeaExport.PlaceOfDeliveryOnBl')"
            :class="variableCss.destinationPort"
          >
            <cargo-advance-select
              :disabled="true"
              :select-type="selectTypeNames.basic_data_Seaport"
              filterable
              :default-value="form.destinationPortCode||''"
              tag-name="englishName"
              no="destinationPortCode"
              :class="importDifferenceField.destinationPortCode ? 'red-border' : ''"
              @parentCallBack="p=>{pm.portChange(p, 'destinationPort')}"
            />
            <special-character-tip :texts="specialCharCheck.destinationPort">
              <el-input v-model="form.destinationPort" :filter-chars="false" :class="importDifferenceField.destinationPort ? 'red-border' : ''" no="55" :disabled="readonly" />
            </special-character-tip>
          </el-form-item>
          <el-form-item :label="$t('SeaExport.BlFinalDestination')">
            <el-input v-model="form.destinationPlace" :filter-chars="false" :class="importDifferenceField.destinationPlace ? 'red-border' : ''" no="56" :disabled="readonly" />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.MethodOfMblPayment')">
            <el-input
              :disabled="true"
              :value="ColumnUtils.paymentTermLabelFunc(job.paymentTermMBL)"
              :class="importDifferenceField.paymentTermMBL ? 'red-border' : ''"
            />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.PlaceOfMblPayment2')">
            <el-input
              :disabled="true"
              :value="form.paymentPlaceBL"
              :class="importDifferenceField.paymentPlaceBL ? 'red-border' : ''"
            />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.TransportationClause')">
            <el-input
              :disabled="true"
              :value="job.freightTerm"
            />
          </el-form-item>
          <el-form-item
            :label="$t('SeaExport.NoOfOriginalBls')"
            :class="variableCss.BLNumber"
          >
            <el-input v-model="form.blNumber" :class="importDifferenceField.blNumber ? 'red-border' : ''" no="57" :disabled="readonly" />
          </el-form-item>
          <el-form-item
            :label="$t('SeaExport.NoOfCopyBls')"
          >
            <el-input v-model="form.blCopyNumber" :class="importDifferenceField.blCopyNumber ? 'red-border' : ''" no="58" :disabled="readonly" />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.PlaceOfIssue')">
            <el-input v-model="form.signPlaceBL" :class="importDifferenceField.signPlaceBL ? 'red-border' : ''" no="59" :disabled="readonly" />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.DateOfIssue')">
            <el-date-picker
              v-model="form.signDateBL"
              :disabled="readonly"
              no="60"
              style="width: 100%"
              type="date"
              value-format="yyyy-MM-dd"
              :class="importDifferenceField.signDateBL ? 'red-border' : ''"
            />
          </el-form-item>
          <el-form-item
            :label="$t('SeaExport.BlRemarks')"
            :class="variableCss.remarks"
          >
            <special-character-tip :texts="specialCharCheck.remarks">
              <cargo-input
                v-model="form.remarks"
                :disabled="readonly"
                :use-read-only="true"
                no="61"
                :class="importDifferenceField.remarks ? variableCss.remarks + ' red-border' : variableCss.remarks"
                type="textarea"
                :rows="5"
                :filter-chars="false"
                @dblclick.native="showAdvanceTextDialog($t('SeaExport.BlRemarks'),form.remarks,val=>{form.remarks=val}, false, null, false, {
                  warningCount: -1,
                  maxChar: 0,
                  autoUppercase: false,
                  autoHalfWord: false
                })"
              />
            </special-character-tip>
          </el-form-item>
        </el-form>
      </div>
      <div class="section form-column">
        <el-form
          :disabled="readonly"
          label-width="108px"
          label-position="right"
          style="height:100%"
        >
          <span class="title">{{ $t('SeaExport.OtherInfo') }}</span>
          <el-form-item :label="$t('SeaExport.BlType')">
            <el-select
              v-model="form.releaseType"
              no="62"
              :class="importDifferenceField.releaseType ? 'red-border' : ''"
              @change="val=>{pm.cmbreleaseTypeMBLChangeHandler(val)}"
            >
              <el-option
                v-for="(item,index) in blModeList"
                :key="index"
                :label="item.name"
                :value="item.serialNumber"
              />
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('SeaExport.BlProperty')">
            <el-select
              no="63"
              :value="job.typeMBL||1"
              :disabled="cmbtypeMBLDisabled"
              @input="val=>{pm.cmbtypeMBLChangeHandler(val)}"
            >
              <el-option
                v-for="(item,index) in BILL_TYPES"
                :key="index"
                :label="isZh ? item.chineseName : item.englishName"
                :value="item.code"
              />
            </el-select>
          </el-form-item>
          <el-form-item
            v-show="job.jointMasterMBLUuid"
            :label="$t('SeaExport.MBLHBR')"
          >
            <el-input :value="job.jointMasterMBL?job.jointMasterMBL.jobNo:''" :disabled="true" />
          </el-form-item>
          <el-form-item
            :label="$t('SeaExport.CheckingStatus')"
            class="red"
          >
            <el-input
              :disabled="true"
              :value="lblCfrState"
              style="margin-bottom: 5px"
            />
            <cargo-button-container
              v-permission="['button_SingleRelease_singleRelease']"
              no="64"
              :disabled="btnReleasingDisabled || !cooperateEdit"
              style="float:right;margin-left:5px"
              @click="pm.btnReleasingClickHandler()"
            >
              <el-button type="primary">{{
                form.cfmState === 10 ? $t('SeaExport.CancelReleasing') : $t('SeaExport.Releasing')
              }}
              </el-button>
            </cargo-button-container>
            <!--取回/撤销取回按钮-->
            <cargo-button-container
              v-permission="['button_SingleRelease_getBack']"
              no="65"
              :disabled="btnGetBackDisabled || !cooperateEdit"
              style="float:right"
              @click="pm.btnGetBackClickHandler()"
            >
              <el-button type="primary">{{
                form.bliStatus === 7 ? $t('SeaExport.CancelGetBack') : $t('SeaExport.Back')
              }}
              </el-button>
            </cargo-button-container>
          </el-form-item>

          <!-- 提单签发状 -->
          <el-form-item :label="$t('SeaExport.BillLadingIssued')" class="red">
            <el-input v-model="billLadingIssued" :disabled="true" />
          </el-form-item>

          <el-form-item
            :label="$t('SeaExport.ReleasingStatus')"
            class="red"
          >
            <el-input
              :disabled="true"
              :value="lblReleaseState"
            />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.RequestReleaseState')" class="red">
            <el-input :value="form.requestReleaseState === 0 ? $t('SeaExport.NotApplying') : $t('SeaExport.Requested')" :disabled="true" />
            <span style="float:left;margin-left:-85px">{{ job.jointMasterMBLUuid ? $t('SeaExport.TicketHasMerged') : (job.typeMBL === BillType.SPLIT_BILL_TYPE.code) ? $t('SeaExport.TicketHasSplit') : '' }}</span>
            <cargo-button-container
              no="requestReleaseState"
              :disabled="btnBLConfirmDisabled || !cooperateEdit"
              style="float:right;margin-left:5px"
              @click="pm.btnRequestReleasingClickHandler()"
            >
              <el-button v-permission="['button_M/HBL_SingleReleaseMBL']" :disabled="job.jointMasterMBLUuid || job.typeMBL === BillType.SPLIT_BILL_TYPE.code" type="primary">
                {{ form.requestReleaseState === 0 ? $t('SeaExport.ApplyForARelease') : $t('SeaExport.WithdrawTheRequestForRelease') }}
              </el-button>
            </cargo-button-container>
          </el-form-item>
          <el-form-item :label="$t('SeaExport.ReleaseEligibleStatus')" class="red">
            <el-input :value="releaseEligibleLabel" :disabled="true" />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.preverifyDate')">
            <el-date-picker
              v-model="form.reviewDate"
              :disabled="true"
              type="date"
              value-format="yyyy-MM-dd"
              style="width: 100%"
            />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.DateOfCargoDetention')">
            <el-date-picker
              v-model="form.withholdDate"
              :disabled="true"
              type="date"
              value-format="yyyy-MM-dd"
              style="width: 100%"
            />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.BlReleasingNo')">
            <el-input
              :disabled="true"
              :value="form.surrenderedNo"
            />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.ReleasingDate')">
            <el-date-picker
              v-model="form.releaseDate"
              :disabled="true"
              type="date"
              value-format="yyyy-MM-dd"
              style="width: 100%"
            />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.ParamRemark')">
            <el-select v-model="form.printParam4" no="66" :class="importDifferenceField.printParam4 ? 'red-border' : ''" :placeholder="readonly ? '' : $t('CargoMsg.Cargo_PleaseSelect')">
              <el-option
                v-for="(item,index) in pm.printParam4Type"
                :key="index"
                :label="item.label"
                :value="item.data"
              />
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('SeaExport.ShippingCompanySCAC')">
            <el-input
              :disabled="true"
              :value="txtCarrierScAc"
            />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.OverseasAgentSCAC')">
            <el-input
              :disabled="true"
              :value="txtBookingAgentScAc"
            />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.ManifestDescriptionOfGoods')">
            <cargo-rich-textarea
              v-model="form.cargoManifestName"
              no="67"
              :disabled="readonly"
              style="height: 110px;"
              :text-chars="0"
              :warning-count="-1"
              wrap-symbol="r"
              :class="importDifferenceField.cargoManifestName ? 'red-border' : ''"
              @dblclick.native="showAdvanceTextDialog($t('SeaExport.ManifestDescriptionOfGoods'),form.cargoManifestName,val=>{form.cargoManifestName=val},false,null,true, {
                warningCount: -1,
                maxChar: 0,
                autoUppercase: false,
                autoHalfWord: false
              })"
            />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.ReasonOfCargoDetention')">
            <el-input
              :disabled="true"
              :value="form.withholdReason"
              type="textarea"
              :rows="5"
            />
          </el-form-item>
          <el-form-item :label="$t('CargoMsg.Cargo_OrderModificationTimes')">
            <auto-number-input v-model="form.modificationCount" :precision="0" :min="0" no="modificationCount" />
          </el-form-item>
          <el-form-item :label="$t('CargoMsg.Cargo_PortRequirement')">
            <el-input v-model="form.portRequirement" no="portRequirement" type="textarea" :rows="5" />
            <div style="display: flex;line-height: 16px;margin-top: 5px;cursor: pointer;" @click="downloadAttachment(form.regionWarehouseMappingUuid)">
              <i class="el-icon-paperclip" style="font-size: 16px;" />
              <div style="font-size: 12px;text-decoration: underline;color: blue;">{{ $t('SystemMaintenance.PortRequirementsRelatedDocuments') }}</div>
            </div>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <!-- 高级文本弹框 -->
    <el-dialog
      v-el-drag-dialog
      :visible.sync="advanceTextDialog.visible"
      :title="advanceTextDialog.title"
      :width="advanceTextDialog.showContact ? '900px' : '600px'"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      append-to-body
      class="app-main-inner edi-bill-search-selector"
    >
      <cargo-rich-textarea
        ref="advanceTextDialogTextarea"
        v-model="advanceTextDialog.value"
        :text-chars="advanceTextDialog.formatObj.maxChar"
        :auto-uppercase="advanceTextDialog.isUppercase"
        :warning-count="advanceTextDialog.formatObj.warningCount"
        :auto-half-word="advanceTextDialog.formatObj.autoHalfWord"
        :disabled="!isEdit"
        style="height: 320px;"
      />
      <div class="app-main-inner-row">
        <el-form
          label-width="50px"
          label-position="left"
        >
          <el-row
            v-show="advanceTextDialog.showContact"
            :gutter="10"
            style="padding-top: 20px;"
          >
            <el-col :span="8">
              <el-form-item
                :label="$t('SeaExport.ContactPerson')"
              >
                <el-input
                  v-model="advanceTextDialog.extendData.contact"
                  :disabled="readonly"
                />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                :label="$t('SeaExport.Tel')"
              >
                <el-input
                  v-model="advanceTextDialog.extendData.mobile"
                  :autocomplete="$t('SeaExport.Tel')"
                  :disabled="readonly"
                />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                :label="$t('SeaExport.Fax')"
              >
                <el-input
                  v-model="advanceTextDialog.extendData.fax"
                  :disabled="readonly"
                />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row
            v-show="advanceTextDialog.showContact"
            :gutter="10"
          >
            <el-col :span="8">
              <el-form-item
                :label="$t('SeaExport.Email2')"
              >
                <el-input
                  v-model="advanceTextDialog.extendData.email"
                  :autocomplete="$t('SeaExport.Email2')"
                  :disabled="readonly"
                />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                :label="$t('SeaExport.ZIP')"
              >
                <el-input
                  v-model="advanceTextDialog.extendData.zipCode"
                  :disabled="readonly"
                />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                :label="$t('SeaExport.City')"
              >
                <!--<cargo-location-select
                  :disabled="readonly"
                  :default-value="advanceTextDialog.extendData.city"
                  style="width:180px;"
                  @change="p=>{advanceTextDialog.extendData.city=p.value}"
                />-->
                <cargo-advance-select
                  :disabled="readonly"
                  :select-type="selectTypeNames.basic_data_Seaport"
                  filterable
                  :default-value="advanceTextDialog.extendData.city"
                  options-width="110px"
                  @parentCallBack="p=>{advanceTextDialog.extendData.city=p.value}"
                />&nbsp;
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div slot="footer">
        <el-button
          v-show="isEdit"
          type="primary"
          @click="finishAdvanceText"
        >{{ $t('common.btn.confirm') }}
        </el-button>
        <el-button @click="advanceTextDialog.visible=false">{{ $t('common.btn.close') }}</el-button>
      </div>
    </el-dialog>
    <!-- 收发通地址弹窗 -->
    <bill-address-dialog
      :visible.sync="billAddressDialog.visible"
      :params="billAddressDialog.params"
      :job="job"
      @callback="codeSearchCallback"
    />
    <!-- 工作单检索弹窗 -->
    <job-no-transcribe-dialog
      :visible.sync="searchBillNoDialog.visible"
      :params="searchBillNoDialog.params"
      @selected="p=>{pm.selectionItemHandler(p)}"
    />
    <!-- 邀请对单弹窗 -->
    <email-input
      v-if="emailInput.visible"
      :visible.sync="emailInput.visible"
      :context="context"
      :job="job"
      source="tabMBL"
      :push-link="SystemConstants.MBL_INVITATION_STATEMENT"
      :is-copy-link="true"
      :job-eamil-data="jobEamilData"
      :send-email-data="emailInput"
      :send-call-back="onEmailExecute"
    />
    <!-- 对单历史弹窗 -->
    <match-history-dialog
      :visible.sync="matchHistoryDialog.visible"
      :cargo-doc-uuid="form.uuid"
    />
    <!-- 回执历史弹窗 -->
    <receipt-history-dialog
      :visible.sync="receiptHistoryDialog.visible"
      :job-uuid="job.uuid||''"
    />
    <!-- 提单日志弹窗 -->
    <status-change-history-dialog
      :visible.sync="statusChangeHistoryDialog.visible"
      :business-data-id="form.uuid"
    />
    <!-- edi弹窗选择器 -->
    <dialog-selector
      :visible.sync="selectorDialog.visible"
      :title="selectorDialog.title"
      :row-data="selectorDialog.rowData"
      @selected="getEDICallback"
    />
    <!-- 报文预览弹窗 -->
    <message-preview-dialog
      :visible.sync="messagePreviewDialog.visible"
      :params="messagePreviewDialog.params"
      @uploadSuccess="{}"
    />
    <edi-doc-window
      v-if="ediDocWindow.visible"
      ref="ediDocWindow"
      :visible="ediDocWindow.visible"
      :global-var="globalVar"
      :edi-status-name="ediStatusName"
      :call-back-func="ediDocWindow.callBackFunc"
      :context="context"
      @close="ediDocWindow.visible =false"
    />
    <!-- 舱单-多段号码规则配置-弹窗 -->
    <multi-seg-num-rules-dialog
      :visible.sync="multiSegNumRulesDialog.visible"
      @callback="multiSegNumRulesCallback"
    />
    <!-- api接口选择弹窗 -->
    <api-popup
      :visible.sync="apiPopup.visible"
      :title="apiPopup.title"
      :interface-type="apiPopup.interfaceType"
      :interface-array="apiPopup.interfaceArray"
      @selectedApi="selectedApiCallback"
    />
    <!-- 错误日志显示弹窗 -->
    <error-log-dialog
      :visible.sync="errorLogDialog.visible"
      :error-log="errorLogDialog.errorLog"
    />
    <!-- 提单补充信息 -->
    <cargo-doc-extend
      :visible.sync="cargoDocExtendDialog.visible"
      :title="cargoDocExtendDialog.title"
      :job-uuid="job.uuid"
      :sea-cargo-doc="form"
      :carrier-id="job.carrierId"
    />
    <!-- 单条业务 配置规则验证弹窗-->
    <checking-window
      v-if="checkingWindow.visible"
      :visible.sync="checkingWindow.visible"
      :lob="job.lob"
      :job="job"
      :check-node="checkingWindow.checkNode"
      :call-back="checkingWindow.callBack"
    />
    <!--取装箱信息件毛体-->
    <sync-container-info-dialog
      ref="syncContainerInfoDialog"
      :visible.sync="syncContainerInfoDialog.visible"
      :change-post-func="syncContainerInfoChangeHandle"
    />
  </div>
</template>

<script>
import { TabMBLPM } from './tabMBLPM'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import cargoInput from '@/components/Cargo/Common/cargoInput'
import billAddressDialog from '@/components/Cargo/Job/billAddressDialog'
import jobNoTranscribeDialog from '@/components/Cargo/Job/jobNoTranscribeDialog'
import emailInput from '@/components/Cargo/Job/emailInput'
import matchHistoryDialog from '@/components/Cargo/Job/matchHistoryDialog'
import receiptHistoryDialog from '@/components/Cargo/Job/receiptHistoryDialog'
import statusChangeHistoryDialog from '@/components/Cargo/Job/statusChangeHistoryDialog'
import soNoInput from '@/components/Cargo/Job/soNoInput'
import cargoLocationSelect from '@/components/Cargo/Common/cargoLocationSelect'
import cargoButtonContainer from '@/components/Cargo/Common/cargoButtonContainer'
import moment from 'moment'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { TabError } from '@/utils/class/TabError'
import ediDocWindow from '@/views/cargo/v0/SeaExport/components/booking/tabs/leadPage/ediDocWindow'
import { BILL_TYPES } from '@/class/cargo/model/parameters/BillType'
import { CargoDocUtil } from '@/class/cargo/model/utils/CargoDocUtil'
import { SeaCargoDoc } from '@/class/model/booking/SeaCargoDoc'
import { SeaExportJob } from '@/class/model/booking/SeaExportJob'
import cargoRichTextarea from '@/components/Cargo/Common/cargoRichTextarea'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import { PrintTemplateManager } from '@/class/cargo/model/utils/PrintTemplateManager'
import { sendHblCargoDocEmail } from '@/api/sendEmailService'
import { BillAddressCommonPM } from '@/class/common/BillAddressCommonPM'
import { getLoading } from '@/utils/utilBaseElement'
import * as jobApi from '@/api/seaExport/seaExportJob'
import { checkCreditInfo } from '@/api/partner/creditInfo'
import * as ediApi from '@/api/seaExport/edi'
import { ModelMap } from '@/class/cargo/model/parameters/ModelMap'
import { getGridSelected } from '@/utils/agGrid'
import { getEDITemplate } from '@/api/sysManage/baseConfig/ediTemplate'
import DialogSelector from '@/views/cargo/v0/SeaExport/components/edi/dialogSelector'
import MessagePreviewDialog from '@/views/cargo/v0/SeaExport/components/edi/messagePreviewDialog'
import { cache } from '@/utils/cacheManager'
import StrUtils from '@/utils/StrUtils'
import ApiPopup from '@/views/cargo/v0/SeaExport/components/edi/apiPopup'
import ErrorLogDialog from '@/views/cargo/v0/SeaExport/components/edi/errorLogDialog'
import MultiSegNumRulesDialog from '@/views/cargo/v0/SeaExport/components/edi/multiSegNumRulesDialog'
import cargoPackingSelect from '@/components/Cargo/Common/cargoPackingSelect'
import AutoNumberInput from '@/components/Cargo/Common/AutoNumberInput'
import specialCharacterTip from '@/components/Cargo/Common/specialCharacterTip'
import * as CargoDocConsts from '@/class/cargo/model/parameters/CargoDocConsts'
import * as BillType from '@/class/cargo/model/parameters/BillType'
import ColumnUtils from '@/utils/ColumnUtils'
import * as EdiSendType from '@/class/cargo/model/parameters/EdiSendType'
import * as CargoDocCfmState from '@/class/cargo/model/parameters/CargoDocCfmState'
import { INTELLIGENT_DOCUMENT_SOURCE_5 } from '@/class/cargo/model/parameters/SystemConstants'
import { getObjectByCache } from '@/utils/basicDataCache'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'
import { CheckCargoDocHistory } from '@/class/model/booking/CheckCargoDocHistory'
import LocalStorageUtilsNew from '@/utils/localStorageUtilsNew'
import CargoDocExtend from '@/views/cargo/v0/SeaExport/components/edi/cargoDocExtend.vue'
import * as ContainerLoadType from '@/class/cargo/model/parameters/ContainerLoadType'
import * as CheckRuleConstants from '@/class/cargo/model/parameters/CheckRuleConstants'
import CheckingWindow from '@/components/Cargo/Job/CheckingManager/CheckingWindow.vue'
import SyncContainerInfoDialog from '@/components/Cargo/Job/syncContainerInfoDialog.vue'
import { PrintTemplateUtil } from '@/class/cargo/model/utils/PrintTemplateUtil'
import { getLoading4Cxt } from '@/utils/utilBaseElement'
import * as EdiType from '@/class/cargo/model/parameters/EdiType'
import { isReleaseEligibleFromDocs } from '@/utils/releaseEligibility'

export default {
  name: 'TabMbl',
  components: {
    CheckingWindow,
    SyncContainerInfoDialog,
    CargoDocExtend,
    MultiSegNumRulesDialog,
    ErrorLogDialog,
    ApiPopup,
    MessagePreviewDialog,
    DialogSelector,
    ediDocWindow,
    AutoNumberInput,
    cargoPackingSelect,
    cargoAdvanceSelect, cargoInput, billAddressDialog, jobNoTranscribeDialog, emailInput, matchHistoryDialog,
    receiptHistoryDialog, soNoInput, statusChangeHistoryDialog, cargoLocationSelect, cargoButtonContainer, cargoRichTextarea, specialCharacterTip
  },
  props: {
    context: {
      type: Object,
      required: true
    },
    action: {
      type: String,
      required: true
    },
    cooperateEdit: { // 能否修改
      type: Boolean,
      default: true
    },
    viewSource: { // 区分是否来源为海出订舱
      type: String,
      required: false,
      default: ''
    }
  },
  data() {
    return {
      jobMblBliStatus: 0,
      billLadingIssued: '',
      SystemConstants,
      ColumnUtils,
      jobEamilData: {},
      isZh: this.$store.getters.language === 'zh',
      visible: false, // 先隐藏，避免组件在初始化完成前，做一些无效的处理（频繁刷新组件、调用接口等）
      pm: new TabMBLPM(this),
      moment,
      BILL_TYPES,
      CargoDocUtil,
      selectTypeNames: TYPE_NAMES,
      LCL_CARGO_TYPE: ContainerLoadType.LCL_CARGO_TYPE,
      isCarrierUserMSC: false,
      mergeHblData: false,
      synchronousShipperCodeAndConsigneeCodeAndNotifyCode: false,
      syncSignDateBl: false,
      maxChars: 34,
      warningCount: 0,
      englishNameMaxChars: 0,
      markMaxChars: 0,
      englishNameWarningCount: 0,
      markWarningCount: 0,
      billEDIApiOpen: false,
      cmbtypeMBLDisabled: false,
      isUppercase: true,
      masterFlag: false,
      blModeList: [
        { serialNumber: 1, code: 'ORIGINAL', name: 'ORIGINAL', localName: this.$t('SeaExport.OriginalNormal') },
        { serialNumber: 2, code: 'SURRENDERED', name: 'SURRENDERED', localName: this.$t('SeaExport.TelexRelease') },
        { serialNumber: 3, code: 'SEA WAYBILL', name: 'SEA WAYBILL', localName: this.$t('SeaExport.TelexRelease') }
      ],
      otherFieldsData: [],
      addrPM: new BillAddressCommonPM(this),
      job: {},
      form: new SeaCargoDoc().fillDefaultValue().getData(),
      otherSelectField: '',
      otherCode: '',
      bliStatus: '',
      lblCfrState: '',
      lblReleaseState: '',
      txtCarrierScAc: '',
      txtBookingAgentScAc: '',
      txtFirstVesselVoyage: '',
      ediDocWindow: {
        callBackFunc: null,
        visible: false
      },
      command1: this.$t('SeaExport.CodeSearching'),
      command2: this.$t('SeaExport.InviteToChecktheBL'),
      variableCss: {
        quantity: '',
        shipperCode: '', // 发货人1
        shipperLine: '', // 发货人1
        shipperLine1: '', // 发货人1
        shipperLine2: '', // 发货人2
        shipperLine3: '', // 发货人3
        shipperLine4: '', // 发货人4
        shipperLine5: '', // 发货人5
        shipperLine6: '', // 发货人6
        shipperLine7: '', // 发货人7
        consigneeCode: '',
        consigneeLine: '', // 收货人1
        consigneeLine1: '', // 收货人1
        consigneeLine2: '', // 收货人2
        consigneeLine3: '', // 收货人3
        consigneeLine4: '', // 收货人4
        consigneeLine5: '', // 收货人5
        consigneeLine6: '', // 收货人6
        consigneeLine7: '', // 收货人7
        notifyCode: '',
        notifyLine: '', // 通知人1
        notifyLine1: '', // 通知人1
        notifyLine2: '', // 通知人2
        notifyLine3: '', // 通知人3
        notifyLine4: '', // 通知人4
        notifyLine5: '', // 通知人5
        notifyLine6: '', // 通知人6
        notifyLine7: '', // 通知人7
        BLNumber: '', // 提单份数
        packing: '', // 包装
        insideQuantity: '', // 小件数
        insidePacking: '', // 小件数包装类型
        dispatchingPlace: '', // (提单发货地)发货地
        weight: '', // 提单毛重
        cubage: '', // 提单体积
        loadingPort: '', // (提单起运港)装货港
        dischargingPort: '', // (提单卸货港)中转港
        destinationPort: '', // (提单交货地)目的港
        cargoEnglishName: '', // 英文品名
        soNo: '',
        soNoTitle: '',
        txtFirstVesselVoyage: '',
        txtFirstVesselVoyageTitle: '',
        mark: '', // 唛头
        remarks: ''// 备注
      },
      specialCharCheck: {
        cargoEnglishName: null,
        mark: null,
        shipperLine1: null,
        shipperLine2: null,
        shipperLine3: null,
        shipperLine4: null,
        shipperLine5: null,
        shipperLine6: null,
        consigneeLine1: null,
        consigneeLine2: null,
        consigneeLine3: null,
        consigneeLine4: null,
        consigneeLine5: null,
        consigneeLine6: null,
        notifyLine1: null,
        notifyLine2: null,
        notifyLine3: null,
        notifyLine4: null,
        notifyLine5: null,
        notifyLine6: null,
        paymentLine1: null,
        paymentLine2: null,
        paymentLine3: null,
        paymentLine4: null,
        paymentLine5: null,
        paymentLine6: null,
        paymentLine7: null,
        hsCode: null,
        remarks: null,
        dispatchingPlace: null,
        loadingPort: null,
        dischargingPort: null,
        destinationPort: null
      },
      syncContainerInfoDialog: {
        visible: false
      },
      advanceTextDialog: {
        visible: false,
        title: '',
        value: '',
        showContact: false,
        extendData: {
          contact: '',
          mobile: '',
          fax: '',
          email: '',
          zipCode: '',
          city: ''
        },
        successCallback: null,
        isUppercase: false,
        formatObj: {
          warningCount: 45,
          maxChar: 45, autoUppercase: false, autoHalfWord: false
        }
      },
      billAddressDialog: {
        visible: false,
        params: {}
      },
      searchBillNoDialog: {
        visible: false,
        params: {}
      },
      emailInput: {
        anonSessionId: '',
        visible: false,
        emailTitle: '',
        emailContent: '',
        fileIdList: ''
      },
      matchHistoryDialog: {
        visible: false
      },
      receiptHistoryDialog: {
        visible: false
      },
      statusChangeHistoryDialog: {
        visible: false
      },
      configMap: new Map(),
      // 组件全局变量
      globalVar: {
        // 业务参数
        selectedJob: null,
        selectedJobKey: null,
        selectedJobs: null,
        selectedJobKeys: null,
        title: '',
        ediType: 0,
        editStatus: 0,
        ediTemplate: null,
        ediDatas: null,
        ediTemplateWin: { uuids: null, item: null },
        // 控制参数
        popMultiSegNumRulesType: 1 // 多段参数规则弹窗类型 1:订舱操作引用弹窗 2: 舱单操作引用弹窗
      },
      alsoNotify: {
        line1: '',
        line2: '',
        line3: ''
      },
      // edi弹窗选择器
      selectorDialog: {
        key: '',
        visible: false,
        title: this.$t('SeaExport.BookingEDI'),
        rowData: []
      },
      // 报文预览弹窗
      messagePreviewDialog: {
        visible: false,
        params: {}
      },
      // 舱单-多段号码规则配置-弹窗
      multiSegNumRulesDialog: {
        visible: false
      },
      // 错误日志显示弹窗
      errorLogDialog: {
        visible: false,
        errorLog: ''
      },
      apiPopup: { // api弹框
        visible: false,
        title: '',
        state: '',
        interfaceType: 1,
        interfaceArray: ''
      },
      ediStatusName: '',
      enableShipperConsignNotify: false, // 是否显示收发通
      INTELLIGENT_DOCUMENT_SOURCE_5,
      cargoDocExtendDialog: { // 提单补充信息弹窗
        visible: false,
        title: '',
        callback: null
      },
      checkingWindow: {
        visible: false,
        checkNode: 0,
        callBack: null
      },
      notUppercaseShipperConsigneNotify: true, // CARGO-47047 收发通大小写控制
      BillType: BillType,
      isUppercaseByConfig: true // CARGO-49117 是否大写
    }
  },
  computed: {
    readonly() {
      if (!this.cooperateEdit) return true
      return !this.isEdit
    },
    isEdit() {
      if (!this.cooperateEdit) return false
      return this.action !== 'look' && !this.job.printHblZbLock && (!this.form.uuid || this.form.state < 2)
    },
    feedBtnDisabled() {
      return this.isEdit || !this.form.uuid || this.form.cfmState === 5
    },
    btnBLConfirmDisabled() {
      return this.isEdit || !this.form.uuid
    },
    btnMergeHblDataVisible() {
      return this.mergeHblData && this.job && this.job.typeHBL === 2
    },
    btnExcelVisible() {
      if (this.context.office.code === 'NB' && this.job.carrierId) {
        const cpy = this.context.companyList.find(p => p.cmpIdx === this.job.carrierId)
        return cpy && (cpy.shortName === 'ZIM' || cpy.shortName === 'CSAV')
      }
      return false
    },
    btnGetBackDisabled() {
      // this.form.bliStatus === 7 ===> 按钮为撤销取回   mblBliStatus不为已取回，按钮就置灰
      // this.form.bliStatus !== 7 ===> 按钮为取回      mblBliStatus=已取回/已接收/已认领 时禁止 操作取回按钮
      return this.isEdit || !this.form.uuid ||
        (this.form.bliStatus === 7 && (this.jobMblBliStatus !== CargoDocCfmState.CARGODOC_CFM_STATE_GET_BACKED.code)) ||
        (this.form.bliStatus !== 7 && (this.jobMblBliStatus === CargoDocCfmState.CARGODOC_CFM_STATE_GET_BACKED.code ||
          this.jobMblBliStatus === CargoDocCfmState.CARGODOC_CFM_STATE_RECEIVED.code ||
          this.jobMblBliStatus === CargoDocCfmState.CARGODOC_CFM_STATE_CLAIMED.code))
    },
    btnReleasingDisabled() {
      return this.isEdit || !this.form.uuid
    },
    user() {
      return this.context.user
    },
    config() {
      return this.context.config
    },
    // 开航日期
    sailingDate() {
      const val = this.syncSignDateBl ? this.job.atd : this.job.etd
      return val ? moment(val).format('YYYY-MM-DD') : null
    },
    isJyd() { // 是否集翊达
      return this.config && String(this.config.get('ToExoSystem')) === 'JYD'
    },
    isTP() { // 是否太平
      return this.config && String(this.config.get('ToExoSystem')) === 'TP'
    },
    isHZ() { // 是宏真
      return this.config && String(this.config.get('ToExoSystem')) === 'HZ'
    },
    isJydEditJobFields() { // 有客服权限，没有操作权限，则不能编辑业务的某些字段【新增业务除外】
      return JobUtils.editJobFields(this.isJyd && this.job.uuid)
    },
    synContainerInfoDisable() {
      // 当存在拆单、并单时 该按钮不可操作
      return !(this.job.typeMBL === BillType.NORMAL_BILL_TYPE.code)
    },
    SEHSCodeMode() { // PILL-1056 / 扩展：2=不同步（不做首次同步）
      return this.config ? Number(this.config.get('SEHSCodeMode')) : 0
    },
    syncMblHsCodeEdit() { // PILL-1056: 0=与基本页签同步；1=各自维护；2=各自维护且不做首次同步
      return this.job.lob === SystemConstants.SE.code && this.SEHSCodeMode > 0
    },
    importDifferenceField() {
      if (!this.job) return {}
      return this.job.differenceMblFields || {}
    },
    releaseEligibleLabel() {
      const eligible = isReleaseEligibleFromDocs(this.job && this.job.seaCargoDoc)
      return eligible ? this.$t('SeaExport.ReleaseEligibleYes') : this.$t('SeaExport.ReleaseEligibleNo')
    }
  },
  watch: {
    'form.bliStatus': {
      handler(val) {
        if (val || val === 0) {
          this.jobMblBliStatus = val
        }
      }
    }
  },
  created() {
    this.context.loading = true
    // await this.context.prepareData()
    // this.mergeHblData = Number(this.config.get('mergeHblData')) === 1
    this.synchronousShipperCodeAndConsigneeCodeAndNotifyCode = Number(this.config.get('synchronousShipperCodeAndConsigneeCodeAndNotifyCode')) === 1
    this.enableShipperConsignNotify = Number(this.config.get('SEBookingEnableShipperConsignNotify')) === 1
    this.notUppercaseShipperConsigneNotify = Number(this.config.get('NotUppercaseShipperConsigneNotify')) !== 1
    this.isUppercaseByConfig = Number(this.config.get('autoUppercaseEnabled')) === 0 // CARGO-49117 英文品名、唛头可以支持小写字 为0就大写 1可以大写可以小写
    this.configMap = this.config
    this.pm.init()
    this.visible = true
    this.context.loading = false
  },
  methods: {
    updateCfm() {
      this.job.mblCfmState = 11
      this.form.cfmState = 11
      this.lblCfrState = ColumnUtils.cfmStatusLabelFunc(this.job.mblCfmState)
    },
    wrapAddr(source, from, to, maxChars) {
      CargoDocUtil.sftAddrInputWrap.call(this, source, from, to, maxChars)
    },
    async onShow(row, isRefresh) {
      this.mergeHblData = Number(this.config.get('mergeHblData')) === 1
      this.billEDIApiOpen = Number(this.config.get('BillEDIApiOpen')) === 1
      this.syncSignDateBl = Number(this.config.get('syncSignDateBl')) === 1
      this.masterFlag = row.masterFlag || false
      this.job = row
      await this.pm.changeJob()
      this.checkSpecialCharacter()
      await this.pm.fillView()
      JobUtils.changeField(this.job, this.job.relatedChangeField)
      this.checkField(this.job)
      this.lblCfrState = ColumnUtils.cfmStatusLabelFunc(this.form.cfmState)
      this.billLadingIssued = ColumnUtils.bliStatusLabelFunc(this.form.bliStatus)
      this.lblReleaseState = ColumnUtils.releaseStateLabelFunc(this.form.releaseState)
      if (!isRefresh) {
        this.pm.showScac()
        this.pm.carrierIsOpenMscEDI()
        await this.pm.editingChanged()
      }
      // 同步值 因为seaCargoDoc 所以要根据取docType = MBL的值
      this.job.seaCargoDoc.forEach(val => {
        if (val.docType === 'MBL') {
          this.jobMblBliStatus = val.bliStatus
        }
      })
    },
    checkField(job) {
      this.variableCss.soNo = job.change_soNo ? 'mbl-red' : ''
      this.variableCss.soNoTitle = job.change_soNo ? 'red' : ''
      this.variableCss.txtFirstVesselVoyage = (job.change_vessel || job.change_voyageFlight) ? 'mbl-red' : ''
      this.variableCss.txtFirstVesselVoyageTitle = (job.change_vessel || job.change_voyageFlight) ? 'red' : ''
    },
    checkSpecialCharacter() {
      if (Number(this.config.get('SpecialCharacterCheck')) === 1) {
        for (const key in this.specialCharCheck) {
          this.specialCharCheck[key] = StrUtils.getSpecialTexts(this.form[key])
        }
      } else {
        for (const key in this.specialCharCheck) {
          this.specialCharCheck[key] = null
        }
      }
    },
    async getSubmitData() {
      // CARGO-20365先触发富文本组件失焦事件去除尾部换行符
      this.$refs.cargoTextarea1.hanldeFormat()
      this.$refs.cargoTextarea2.hanldeFormat()
      this.pm.fillModel()
      this.validateForm()
      const job = { ...this.job }
      // 不进入并单页签和基本页签也要入库并单数据
      const cargoDocList = await new SeaExportJob(this.job).getSeaCargoDoc()
      let mbl2Uuid = ''
      let mbl2Doc
      for (const e of cargoDocList) {
        if (e.docType === 'MBL2') {
          mbl2Uuid = e.uuid
          mbl2Doc = e
        }
      }
      if (job.typeMBL === BillType.MERGE_BILL_TYPE.code) {
        let hasMergeMbl2 = false
        for (const e of cargoDocList) {
          if (e.docType === CargoDocConsts.MBL2) {
            hasMergeMbl2 = true
          }
        }
        if (!hasMergeMbl2) {
          let mbl2
          if (mbl2Uuid) {
            mbl2.uuid = mbl2Uuid
            mbl2 = mbl2Doc
          } else {
            mbl2 = new SeaCargoDoc().fillDefaultValue().getData()
            this.initCargoDoc(mbl2, job, 'MBL2')
          }
          this.job.seaCargoDoc.push(mbl2)
        }
      } else if (mbl2Uuid) {
        // 提单种类修改为不是并单要删除并单记录
        mbl2Doc.delete = true
        this.job.seaCargoDoc.push(mbl2Doc)
      }
      const data = {
        job,
        seaCargoDoc: this.job.seaCargoDoc
      }
      const billOfLadingSynMode = this.config ? parseInt(this.config.get('BillOfLadingSynMode')) : 0
      const expression = this.config ? parseInt(this.config.get('ContainerUpdateJobQCW')) : 0
      const isXyCw = this.config ? String(this.config.get('ToExoSystem')) === 'XYCW' : false
      if (isXyCw && billOfLadingSynMode === 2 && expression === 3 && this.job.containers && this.job.containers.length > 0) {
        data.containers = this.job.containers || []
      }
      return data
    },
    validateForm() {
      // UI自定义中用到
    },
    executeTask() {
      this.pm.executeTask()
    },
    initCargoDoc(doc, row, docType) {
      new SeaCargoDoc(doc).reset()
      doc.docType = docType
      doc.mark = row.mark
      doc.cargoEnglishName = row.cargoEnglishName
      // if (docType === 'MBL') {
      doc.notifyLine1 = 'SAME AS CONSIGNEE'
      // }
      // 提单发货地，应该是seaopinput.placeOfReceipt
      doc.dispatchingPlace = row.dispatchingPlace
      doc.dispatchingPlaceCode = row.dispatchingPlaceCode
      // 提单起运港
      if (row.loadingPortCode) {
        console.log('posr', this)
        const ports = this.context.seaPortList.filter(p => p.code === row.loadingPortCode)
        if (ports && ports.length > 0) {
          doc.loadingPort = ports[0].englishName
          doc.loadingPortCode = row.loadingPortCode
        }
      }
      // 提单卸货港
      if (row.dischargingPortCode) {
        const ports = this.context.seaPortList.filter(p => p.code === row.dischargingPortCode)
        if (ports && ports.length > 0) {
          doc.dischargingPort = ports[0].englishName
          doc.dischargingPortCode = row.dischargingPortCode
        }
      }
      // 提单目的港
      if (row.destinationPortCode) {
        const ports = this.context.seaPortList.filter(p => p.code === row.destinationPortCode)
        if (ports && ports.length > 0) {
          doc.destinationPort = ports[0].englishName
          doc.destinationPortCode = row.destinationPortCode
        }
      }
      if (doc.docType !== 'MBL' && doc.docType !== 'MBL2') {
        // 提单收货地
        doc.destinationPlace = row.destinationPlace
      }
      if (doc.docType === 'MBL' && row.masterFlag) {
        doc.shipperLine1 = this.office.seaAddressLine1
        doc.shipperLine2 = this.office.seaAddressLine2
        doc.shipperLine3 = this.office.seaAddressLine3
        doc.shipperLine4 = this.office.seaAddressLine4
        doc.shipperLine5 = this.office.seaAddressLine5
        doc.shipperLine6 = this.office.seaAddressLine6
      }
      // 通过参数BillOfLadingSynMode同步件毛体和包装
      CargoDocUtil.changeJobSynToBillOfLading(row, doc)
      // 根据参数判断是否同步小件数包装
      const isInsidePacking = Number(this.config.get('seaInsidePacking'))
      if (isInsidePacking === 1) {
        doc.insidePacking = row.insidePacking
      }
      // doc.issuerBL = 'UBI'
      ColumnUtils.customOrderFormTypeFunc(doc)
      // 新增时，如果已经选择提单方式，会重置为默认值
      if (!doc.releaseType) {
        const releaseType = Number(this.config.get('ReleaseTypeDefaultValue'))
        if (releaseType === 1) {
          doc.releaseType = 1
          doc.blNumber = 'THREE'
        } else if (releaseType === 2) {
          doc.releaseType = 2
          doc.blNumber = 'ONE'
        } else if (releaseType === 3) {
          doc.releaseType = 3
          doc.blNumber = 'ONE'
        } else if (releaseType === 4) {
          let type
          if (doc.docType === 'MBL') {
            type = LocalStorageUtilsNew.getConfiguration('SE_MBL_BL_MODEL')
          } else if (doc.docType === 'HBL') {
            type = LocalStorageUtilsNew.getConfiguration('SE_HBL_BL_MODEL')
          }
          doc.releaseType = type || 1
          doc.BLNumber = 'ONE'
          if (doc.releaseType === 1) {
            doc.BLNumber = 'THREE'
          }
        }
      } else { // 重置提单份数
        if (doc.releaseType === 1) {
          doc.BLNumber = 'THREE'
        } else {
          doc.BLNumber = 'ONE'
        }
      }
      doc.state = 1
    },
    commandHandle(command) {
      switch (command) {
        case this.$t('SeaExport.CodeSearching'):
          this.billAddressDialog.params.isPortFilter = false
          this.billAddressDialog.params.shipperCode = this.form.shipperCode
          this.billAddressDialog.params.consigneeCode = this.form.consigneeCode
          this.billAddressDialog.params.notifyCode = this.form.notifyCode
          this.billAddressDialog.params.shipperField = 'shipperCode'
          this.billAddressDialog.params.consigneeField = 'consigneeCode'
          this.billAddressDialog.params.notifyField = 'notifyCode'
          this.billAddressDialog.params.mbl = true
          this.billAddressDialog.visible = true
          break
        case this.$t('SeaExport.CopyFromTheLastTime'):
          this.pm.onCopy1()
          break
        case this.$t('SeaExport.CopyFromOtherBill'):
          Object.assign(this.searchBillNoDialog.params, {
            docType: 'MBL',
            selectType: 'single',
            job: this.job
          })
          this.searchBillNoDialog.visible = true
          break
        case this.$t('SeaExport.CopyFromHbl'):
          this.pm.onCopyHBL()
          break
        case this.$t('SeaExport.InviteToChecktheBL'):
          this.pm.inviteConfirmBL()
          JobUtils.checkBillTip(this.form, this.doInviteConfirmData)
          break
        case this.$t('SeaExport.ConfirmChecking'):
          this.pm.confirmBL()
          break
        case this.$t('SeaExport.CheckingHistory'):
          this.matchHistoryDialog.visible = true
          break
        case this.$t('SeaExport.ReceiptHistory'):
          this.receiptHistoryDialog.visible = true
          break
        case this.$t('SeaExport.BillingOfLadingRecordManager'):
          this.statusChangeHistoryDialog.visible = true
          break
        case this.$t('SeaExport.IdentificationList'):
          this.$router.push({
            name: 'OcrRecognition',
            query: {
              uuid: this.job.uuid,
              docUuid: this.form.uuid,
              source: INTELLIGENT_DOCUMENT_SOURCE_5.code
            }
          })
          break
      }
    },
    doInviteConfirmData() {
      SeaCargoDoc.getCfmAddress(this.form.uuid, this.form.version, this.user.tenantName, this.job.jobNo, this.$store.getters.currentOfficeId, this.user.email).then(data => {
        if (data.cargoDoc) {
          Object.assign(this.form, data.cargoDoc)
          this.pm.getDocCfmState()
        }
        this.emailInput.emailTitle = ''
        if (this.form.hblNbr2) {
          this.emailInput.emailTitle = `${this.$t('SeaExport.ConfirmationBillOfLading')}-${this.form.hblNbr2}(${this.context.office.chineseName})`
        } else {
          this.emailInput.emailTitle = `${this.$t('SeaExport.ConfirmationBillOfLading')}(${this.context.office.chineseName})`
        }
        this.emailInput.anonSessionId = data.anonSessionId
        this.emailInput.emailContent = data.url
        this.emailInput.fileIdList = ''
        this.emailInput.visible = true
        this.jobEamilData = {
          anonSessionId: this.emailInput.anonSessionId,
          jobuuid: this.job.uuid,
          cargoDocUuid: this.form.uuid,
          format: PrintTemplateManager.FORMAT_PDF,
          createdBy: this.$store.getters.userId,
          templateType: this.form.docType,
          className: 'CargoDoc',
          classNameType: SystemConstants.BOOKING,
          officeId: this.$store.getters.currentOfficeId,
          tenantName: this.user.tenantName
        }
      })
    },
    codeSearchCallback(data) {
      if (data.shipperInfo) {
        this.splitShipperLine(data.shipperInfo)
      }
      if (data.consigneeInfo) {
        this.splitConsigneeLine(data.consigneeInfo)
      }
      if (data.notifyInfo) {
        this.splitNotifyLine(data.notifyInfo)
      }
      if (data.hasOwnProperty('shipperCode')) {
        this.form['shipperCode'] = data.shipperCode || ''
      }
      if (data.hasOwnProperty('consigneeCode')) {
        this.form['consigneeCode'] = data.consigneeCode || ''
      }
      if (data.hasOwnProperty('notifyCode')) {
        this.form['notifyCode'] = data.notifyCode || ''
      }
      this.$emit('changeDataSFT', data)
    },
    mergeShipperLine() {
      let result = ''
      for (let i = 1; i < 7; ++i) {
        result += this.form['shipperLine' + i] || ''
        result += '\n'
      }
      result += (this.form['shipperLine7'] || '')
      return result.trimEnd()
    },
    splitShipperLine(val, extendData) {
      let fromIndex = 0
      let i = 1
      for (; i < 7; ++i) {
        const index = val.indexOf('\n', fromIndex)
        if (index === -1) {
          break
        }
        this.form['shipperLine' + i] = val.substring(fromIndex, index)
        fromIndex = index + 1
      }
      this.form['shipperLine' + i] = val.substring(fromIndex)
      for (++i; i < 8; ++i) {
        this.form['shipperLine' + i] = ''
      }
      if (extendData) {
        this.form.shipperContact = extendData.contact
        this.form.shipperMobile = extendData.mobile
        this.form.shipperFax = extendData.fax
        this.form.shipperEmail = extendData.email
        this.form.shipperZipCode = extendData.zipCode
        this.form.shipperCity = extendData.city
      }
    },
    mergeConsigneeLine() {
      let result = ''
      for (let i = 1; i < 7; ++i) {
        result += this.form['consigneeLine' + i] || ''
        result += '\n'
      }
      result += (this.form['consigneeLine7'] || '')
      return result.trimEnd()
    },
    splitConsigneeLine(val, extendData) {
      let fromIndex = 0
      let i = 1
      for (; i < 7; ++i) {
        const index = val.indexOf('\n', fromIndex)
        if (index === -1) {
          break
        }
        this.form['consigneeLine' + i] = val.substring(fromIndex, index)
        fromIndex = index + 1
      }
      this.form['consigneeLine' + i] = val.substring(fromIndex)
      for (++i; i < 8; ++i) {
        this.form['consigneeLine' + i] = ''
      }
      if (extendData) {
        this.form.consigneeContact = extendData.contact
        this.form.consigneeMobile = extendData.mobile
        this.form.consigneeFax = extendData.fax
        this.form.consigneeEmail = extendData.email
        this.form.consigneeZipCode = extendData.zipCode
        this.form.consigneeCity = extendData.city
      }
    },
    mergeNotifyLine() {
      let result = ''
      for (let i = 1; i < 7; ++i) {
        result += this.form['notifyLine' + i] || ''
        result += '\n'
      }
      result += (this.form['notifyLine7'] || '')
      return result.trimEnd()
    },
    mergePaymentLine() {
      let result = ''
      for (let i = 1; i < 7; ++i) {
        result += this.form['paymentLine' + i] || ''
        result += '\n'
      }
      result += (this.form['paymentLine7'] || '')
      return result.trimEnd()
    },
    splitPaymentLine(val, extendData) {
      let fromIndex = 0
      let i = 1
      for (; i < 7; ++i) {
        const index = val.indexOf('\n', fromIndex)
        if (index === -1) {
          break
        }
        this.form['paymentLine' + i] = val.substring(fromIndex, index)
        fromIndex = index + 1
      }
      this.form['paymentLine' + i] = val.substring(fromIndex)
      for (++i; i < 8; ++i) {
        this.form['paymentLine' + i] = ''
      }
      if (extendData) {
        this.form.paymentContact = extendData.contact
        this.form.paymentPhone = extendData.mobile
        this.form.paymentFax = extendData.fax
        this.form.paymentEmail = extendData.email
        this.form.paymentPostalCode = extendData.zipCode
        this.form.paymentCity = extendData.city
      }
    },
    splitNotifyLine(val, extendData) {
      let fromIndex = 0
      let i = 1
      for (; i < 7; ++i) {
        const index = val.indexOf('\n', fromIndex)
        if (index === -1) {
          break
        }
        this.form['notifyLine' + i] = val.substring(fromIndex, index)
        fromIndex = index + 1
      }
      this.form['notifyLine' + i] = val.substring(fromIndex)
      for (++i; i < 8; ++i) {
        this.form['notifyLine' + i] = ''
      }
      if (extendData) {
        this.form.notifyContact = extendData.contact
        this.form.notifyMobile = extendData.mobile
        this.form.notifyFax = extendData.fax
        this.form.notifyEmail = extendData.email
        this.form.notifyZipCode = extendData.zipCode
        this.form.notifyCity = extendData.city
      }
    },
    mergeDgconsignLine() {
      let result = ''
      for (let i = 1; i < 7; ++i) {
        result += this.form['dgconsignLine' + i] || ''
        result += '\n'
      }
      result += (this.form['dgconsignLine7'] || '')
      return result.trimEnd()
    },
    splitDgconsignLine(val, extendData) {
      let fromIndex = 0
      let i = 1
      for (; i < 7; ++i) {
        const index = val.indexOf('\n', fromIndex)
        if (index === -1) {
          break
        }
        this.form['dgconsingLine' + i] = val.substring(fromIndex, index)
        fromIndex = index + 1
      }
      this.form['dgconsignLine' + i] = val.substring(fromIndex)
      for (++i; i < 8; ++i) {
        this.form['dgconsignLine' + i] = ''
      }
      if (extendData) {
        this.form.dgconsignContact = extendData.contact
        this.form.dgconsignMobile = extendData.mobile
        this.form.dgconsignFax = extendData.fax
        this.form.dgconsignEmail = extendData.email
        this.form.dgconsignZipCode = extendData.zipCode
        this.form.dgconsignCity = extendData.city
      }
    },
    mergeElseInvoiceLine() {
      let result = ''
      for (let i = 1; i < 7; ++i) {
        result += this.form['elseInvoiceLine' + i] || ''
        result += '\n'
      }
      result += (this.form['elseInvoiceLine7'] || '')
      return result.trimEnd()
    },
    splitElseInvoiceLine(val, extendData) {
      let fromIndex = 0
      let i = 1
      for (; i < 7; ++i) {
        const index = val.indexOf('\n', fromIndex)
        if (index === -1) {
          break
        }
        this.form['elseInvoiceLine' + i] = val.substring(fromIndex, index)
        fromIndex = index + 1
      }
      this.form['elseInvoiceLine' + i] = val.substring(fromIndex)
      for (++i; i < 8; ++i) {
        this.form['elseInvoiceLine' + i] = ''
      }
      if (extendData) {
        this.form.elseInvoiceContact = extendData.contact
        this.form.elseInvoiceMobile = extendData.mobile
        this.form.elseInvoiceFax = extendData.fax
        this.form.elseInvoiceEmail = extendData.email
        this.form.elseInvoiceZipCode = extendData.zipCode
        this.form.elseInvoiceCity = extendData.city
      }
    },
    showShipperDialog() {
      const extendData = {
        contact: this.form.shipperContact,
        mobile: this.form.shipperMobile,
        fax: this.form.shipperFax,
        email: this.form.shipperEmail,
        zipCode: this.form.shipperZipCode,
        city: this.form.shipperCity
      }
      this.showAdvanceTextDialog(this.$t('SeaExport.Shipper'), this.mergeShipperLine(), this.splitShipperLine, this.isCarrierUserMSC, extendData, this.notUppercaseShipperConsigneNotify, {
        warningCount: this.warningCount,
        maxChar: this.maxChars, autoUppercase: true, autoHalfWord: true
      })
    },
    showConsigneeDialog() {
      const extendData = {
        contact: this.form.consigneeContact,
        mobile: this.form.consigneeMobile,
        fax: this.form.consigneeFax,
        email: this.form.consigneeEmail,
        zipCode: this.form.consigneeZipCode,
        city: this.form.consigneeCity
      }
      this.showAdvanceTextDialog(this.$t('SeaExport.Consignee'), this.mergeConsigneeLine(), this.splitConsigneeLine, this.isCarrierUserMSC, extendData, this.notUppercaseShipperConsigneNotify, {
        warningCount: this.warningCount,
        maxChar: this.maxChars, autoUppercase: true, autoHalfWord: true
      })
    },
    showNotifyDialog() {
      const extendData = {
        contact: this.form.notifyContact,
        mobile: this.form.notifyMobile,
        fax: this.form.notifyFax,
        email: this.form.notifyEmail,
        zipCode: this.form.notifyZipCode,
        city: this.form.notifyCity
      }
      this.showAdvanceTextDialog(this.$t('SeaExport.NotifyParty'), this.mergeNotifyLine(), this.splitNotifyLine, this.isCarrierUserMSC, extendData, this.notUppercaseShipperConsigneNotify, {
        warningCount: this.warningCount,
        maxChar: this.maxChars, autoUppercase: true, autoHalfWord: true
      })
    },
    showPaymentDialog() {
      const extendData = {
        contact: this.form.paymentContact,
        mobile: this.form.paymentPhone,
        fax: this.form.paymentFax,
        email: this.form.paymentEmail,
        zipCode: this.form.paymentPostalCode,
        city: this.form.paymentCity
      }
      this.showAdvanceTextDialog(this.$t('CargoMsg.Cargo_Payment1'), this.mergePaymentLine(), this.splitPaymentLine, this.isCarrierUserMSC, extendData, true, {
        warningCount: this.warningCount,
        maxChar: this.maxChars, autoUppercase: true, autoHalfWord: true
      })
    },
    showDgconsignDialog() {
      const extendData = {
        contact: this.form.dgconsignContact,
        mobile: this.form.dgconsignMobile,
        fax: this.form.dgconsignFax,
        email: this.form.dgconsignEmail,
        zipCode: this.form.dgconsignZipCode,
        city: this.form.dgconsignCity
      }
      this.showAdvanceTextDialog('DGCONSIGN', this.mergeDgconsignLine(), this.splitDgconsignLine, this.isCarrierUserMSC, extendData, true, {
        warningCount: this.warningCount,
        maxChar: this.maxChars, autoUppercase: true, autoHalfWord: true
      })
    },
    showElseInvoiceDialog() {
      const extendData = {
        contact: this.form.elseInvoiceContact,
        mobile: this.form.elseInvoiceMobile,
        fax: this.form.elseInvoiceFax,
        email: this.form.elseInvoiceEmail,
        zipCode: this.form.elseInvoiceZipCode,
        city: this.form.elseInvoiceCity
      }
      this.showAdvanceTextDialog('ELSEINVOICE', this.mergeElseInvoiceLine(), this.splitElseInvoiceLine, true, extendData, true, {
        warningCount: this.warningCount,
        maxChar: this.maxChars, autoUppercase: true, autoHalfWord: true
      })
    },
    placeholderSFT(i) {
      return JobUtils.placeholderSFT(this.isTP, i)
    },
    showAdvanceTextDialog(title, value, successCallback, showContact = false, extendData = null, isUppercase = false, formatObj = null) {
      this.advanceTextDialog.title = title
      this.advanceTextDialog.value = value
      if (title === 'ALSO NOTIFY') {
        this.advanceTextDialog.showContact = this.isCarrierUserMSC
      } else {
        this.advanceTextDialog.showContact = showContact
      }
      if (showContact) {
        if (extendData) {
          Object.assign(this.advanceTextDialog.extendData, extendData)
        } else {
          for (const key in this.advanceTextDialog.extendData) {
            this.advanceTextDialog.extendData[key] = ''
          }
        }
      }
      this.advanceTextDialog.successCallback = successCallback
      this.advanceTextDialog.isUppercase = isUppercase
      this.advanceTextDialog.visible = true
      this.$nextTick(() => {
        this.$refs.advanceTextDialogTextarea.editor.focus()
      })
      const defaultFormatObj = {
        warningCount: 45,
        maxChar: 45, autoUppercase: false, autoHalfWord: false
      }
      this.advanceTextDialog.formatObj = formatObj ? { ...defaultFormatObj, ...formatObj } : defaultFormatObj
    },
    finishAdvanceText() {
      const successCallback = this.advanceTextDialog.successCallback
      if (successCallback && typeof successCallback === 'function') {
        if (this.advanceTextDialog.showContact) {
          successCallback(this.advanceTextDialog.value, this.advanceTextDialog.extendData)
        } else {
          successCallback(this.advanceTextDialog.value)
        }
      }
      this.advanceTextDialog.visible = false
    },
    formatChange(detail) {
      this.form.showDetail = detail
      // 处理ALSO NOTIFY数据
      if (this.form.alsoNotify) {
        if (detail) {
          const alsoData = this.form.alsoNotify.split('\r')
          if (alsoData.length > 0) {
            this.alsoNotify.line1 = alsoData[0]
          }
          if (alsoData.length > 1) {
            this.alsoNotify.line2 = alsoData[1]
          }
          if (alsoData.length > 2) {
            this.alsoNotify.line3 = alsoData[2]
          }
        }
      }
    },
    summarizeAlso(val) {
      this.form.alsoNotify = val
      if (this.form.alsoNotify) {
        const alsoData = this.form.alsoNotify.split('\n')
        if (alsoData.length > 0) {
          this.alsoNotify.line1 = alsoData[0]
        }
        if (alsoData.length > 1) {
          this.alsoNotify.line2 = alsoData[1]
        }
        if (alsoData.length > 2) {
          this.alsoNotify.line3 = alsoData[2]
        }
      } else {
        this.alsoNotify.line1 = ''
        this.alsoNotify.line2 = ''
        this.alsoNotify.line3 = ''
      }
    },
    alsoChange() {
      this.form.alsoNotify = this.alsoNotify.line1 + '\r' + this.alsoNotify.line2 + '\r' + this.alsoNotify.line3
    },
    // 组装打印参数
    getPrintData() {
      const params = {}
      if (this.form) {
        // params.cargoDocUuid = this.form.uuid
        // params.DOC_UUID = this.form.uuid
        PrintTemplateUtil.buildPrintDataByMbl(this.form, params)
        params.category = 'MBL'
        params.ctx = new SeaExportJob(this.job)
      }
      return params
    },
    getClass(key, index) {
      const variableCss = this.variableCss[key + index]
      const shouldWarn = this.warningCount !== -1 && this.form[key + index] && this.form[key + index].length > this.warningCount
      if (variableCss || shouldWarn) {
        return 'red'
      }
      return ''
    },
    /**
     * @private
     * 邀请对单邮件callBack
     * 返回方法
     */
    onEmailExecute(mailSubject, mailTo, mailCc, content, mailType, mailContent, pushLink) {
      const item = {}
      item.mailTo = mailTo
      item.pushLink = pushLink
      item.mailSubject = mailSubject
      item.mailCc = mailCc
      item.mailBcc = ''
      item.mailFrom = ''
      // item.mailFrom = this.getMailFrom() // 后端已经写死了，此方法无用
      item.cfmUrl = content
      item.anonSessionId = this.emailInput.anonSessionId
      item.jobuuid = this.job.uuid
      item.cargoDocUuid = this.form.uuid
      item.format = PrintTemplateManager.FORMAT_PDF
      item.createdBy = this.$store.getters.userId
      item.templateType = this.form.docType
      item.className = 'CargoDoc'
      item.classNameType = SystemConstants.BOOKING
      item.officeId = this.$store.getters.currentOfficeId
      item.tenantName = this.user.tenantName
      item.mailType = mailType || ''
      item.mailContent = mailContent || ''
      sendHblCargoDocEmail(item).then(res => {
        if (res.ok) {
          this.emailInput.visible = false
          this.$message.success(this.$t('CargoMsg.Cargo_EMSSCM'))
          this.pm.statusHistoryWaitConfirmSuccessHandler()
        } else {
          this.$message.warning(this.$t('SeaExport.MailSendingFailed'))
        }
      })
    },
    // CARGO-46703 对EDI的货物明细取值进行校验
    async toBlPre(index) {
      // 定义EDI相关的路径数组
      const blEdiIndexs = ['FTP1', 'FTP0', 'API0', 'API1']
      // 只处理发送edi 其他走原本的逻辑
      if (blEdiIndexs.includes(index)) {
        // 判断是否开启验证规则
        const useCheckRule = Number(this.configMap.get('useCheckRule')) === 1
        // 查询是否存在节点
        const checkNodeFlag = await JobUtils.hasCheckRuleCondition(true, CheckRuleConstants.NODE_LADING_BILL_EDI_UPLOAD.code, this.$store.getters.currentOfficeId)
        if (useCheckRule && checkNodeFlag) {
          this.checkingWindow.visible = true
          this.checkingWindow.checkNode = CheckRuleConstants.NODE_LADING_BILL_EDI_UPLOAD.code
          this.checkingWindow.callBack = () => { this.toBl(index) }
        } else {
          this.toBl(index)
        }
      } else {
        this.toBl(index)
      }
    },
    // 提单发送Ftp
    toBl(index) {
      this.selectorDialog.key = 'bl'
      this.common().getSelectedJobs()
      switch (index) {
        case this.$t('SeaExport.Correct'):
          this.ediStatusName = this.$t('SeaExport.CorrectionOfBillOfLading')
          this.blHandler().btnBlEdiEditClickHandler()
          break
        case 'FTP1':
          this.ediStatusName = this.$t('SeaExport.OriginalBillOfLading')
          this.blHandler().btnBlEdiNewClickHandler()
          break
        case 'FTP0':
          this.ediStatusName = this.$t('SeaExport.CorrectionOfBillOfLading')
          this.blHandler().btnBlEdiEditClickHandler()
          break
        case 'API0':
          this.ediStatusName = this.$t('SeaExport.OriginalBillOfLading')
          this.bookingEDIApi('9')
          break
        case 'API1':
          this.ediStatusName = this.$t('SeaExport.CorrectionOfBillOfLading')
          this.bookingEDIApi('5')
          break
        default:
          this.ediStatusName = this.$t('SeaExport.OriginalBillOfLading')
          this.blHandler().btnBlEdiNewClickHandler()
          break
      }
    },
    // 提单操作处理器
    blHandler() {
      const self = this
      // 选择事件 - bl.origin
      const btnBlEdiNewClickHandler = async() => {
        await self.common().selectedJobItemClick()
        const job = self.globalVar.selectedJob
        if (self.common().needLoadContainers(job)) {
          self.loading = getLoading()
          const params = {
            job: self.job,
            Containers: true
          }
          jobApi.loadJobParams(params).then(response => {
            onContainerLoaded(response)
          })
            .finally(() => self.loading.close())
        } else {
          addBillEdi()
        }
      }
      // 选择事件 - bl.correct
      const btnBlEdiEditClickHandler = async() => {
        await self.common().selectedJobItemClick()
        if (self.common().checkConfig('creditOpen', '1')) {
          const accountKey = self.globalVar.selectedJob.customerId
          checkCreditInfo({ [accountKey]: accountKey, jobUuid: self.globalVar.selectedJob.uuid }).then(resp => {
            let canEdit = true
            const creditInfo = resp.data !== null ? resp.data[0] : null
            if (creditInfo) {
              let tip = ''
              if (creditInfo.amountExceeded || creditInfo.dateExceeded) {
                const config = {}
                const creditBlock = this.configMap.get('creditBlockEDI').split(',')
                creditBlock.forEach(c => {
                  config[c.split('-')[0]] = c.split('-')[1] === '1'
                })
                if (config.bl) {
                  if (creditInfo.amountExceeded) {
                    tip += this.$t('Partners.limit')
                  }
                  if (creditInfo.dateExceeded) {
                    tip += this.$t('Partners.accountPeriod')
                  }
                  canEdit = false
                  self.$message.info(this.$t('SeaExport.CreditControlTheClient') + tip + this.$t('SeaExport.HasExceededCannotEDI'))
                }
              }
            }
            if (canEdit) {
              self.globalVar.title = this.$t('SeaExport.CorrectionBillOfLading')
              self.globalVar.ediType = 2
              self.globalVar.editStatus = 4
              if (self.common().checkConfig('useEDITemplate', '1')) {
                self.common().showEDITemplateWin([self.globalVar.selectedJobKey])
              } else {
                getLadingBillEDI()
              }
            }
          })
        } else {
          self.globalVar.title = this.$t('SeaExport.CorrectionBillOfLading')
          self.globalVar.ediType = 2
          self.globalVar.editStatus = 4
          if (self.common().checkConfig('useEDITemplate', '1')) {
            self.common().showEDITemplateWin([self.globalVar.selectedJobKey])
          } else {
            getLadingBillEDI()
          }
        }
      }

      // >>>====== 内部和涉及各类弹窗回调方法 <<<=====
      // 添加提单edi
      const onContainerLoaded = (response) => {
        self.globalVar.selectedJob.containers = response.data.containers
        addBillEdi()
      }
      const checkContainerUsage = () => {
        if (self.common().checkConfig('ExportEdiCheckContainerUsage', '0')) {
          return true
        }
        let totalQuantity = 0
        let totalWeight = 0.0
        let totalCubage = 0.0
        const job = self.globalVar.selectedJob
        for (const index in job.containers) {
          const container = job.containers[index]
          for (const index1 in container.containerUsage) {
            const containerUsage = container.containerUsage[index1]
            totalQuantity += containerUsage.quantity
            totalWeight += containerUsage.weight
            totalCubage += containerUsage.cubage
          }
        }
        totalQuantity = Number(totalQuantity.toFixed())
        totalWeight = Number(totalWeight.toFixed(3))
        totalCubage = Number(totalCubage.toFixed(3))

        if (totalQuantity !== (job.quantityActual ? job.quantityActual : 0)) {
          return false
        }
        let diff = Math.abs(totalWeight - (job.weightActual ? job.weightActual : 0))
        if (diff > 0.001) return false// special handlement for floating number.

        diff = Math.abs(totalCubage - (job.cubageActual ? job.cubageActual : 0))
        return diff <= 0.001
      }
      const addBillEdi = () => {
        if (self.common().checkConfig('creditOpen', '1')) {
          const accountKey = self.globalVar.selectedJob.customerId
          checkCreditInfo({ [accountKey]: accountKey, jobUuid: self.globalVar.selectedJob.uuid }).then(resp => {
            let canEdit = true
            const creditInfo = resp.data !== null ? resp.data[0] : null
            if (creditInfo) {
              let tip = ''
              if (creditInfo.amountExceeded || creditInfo.dateExceeded) {
                const config = {}
                const creditBlock = this.configMap.get('creditBlockEDI').split(',')
                creditBlock.forEach(c => {
                  config[c.split('-')[0]] = c.split('-')[1] === '1'
                })
                if (config.bl) {
                  if (creditInfo.amountExceeded) {
                    tip += this.$t('Partners.limit')
                  }
                  if (creditInfo.dateExceeded) {
                    tip += this.$t('Partners.accountPeriod')
                  }
                  canEdit = false
                  self.$message.warning(this.$t('SeaExport.CreditControlTheClient') + tip + this.$t('SeaExport.HasExceededCannotEDI'))
                }
              }
            }
            if (canEdit) {
              if (checkContainerUsage()) {
                self.globalVar.title = this.$t('SeaExport.BlEdi')
                self.globalVar.ediType = 2
                self.globalVar.editStatus = 9
                if (self.common().checkConfig('useEDITemplate', '1')) {
                  self.common().showEDITemplateWin([self.globalVar.selectedJobKey])
                } else {
                  getLadingBillEDI()
                }
              } else {
                self.$message.warning(this.$t('SeaExport.PackingDataNotCconsistent'))
              }
            }
          })
        } else {
          if (checkContainerUsage()) {
            self.globalVar.title = this.$t('SeaExport.BlEdi')
            self.globalVar.ediType = 2
            self.globalVar.editStatus = 9
            if (self.common().checkConfig('useEDITemplate', '1')) {
              self.common().showEDITemplateWin([self.globalVar.selectedJobKey])
            } else {
              getLadingBillEDI()
            }
          } else {
            self.$message.warning(this.$t('SeaExport.PackingDataNotCconsistent'))
          }
        }
      }
      const getLadingBillEDI = () => {
        self.loading = getLoading()
        const params = {
          jobUuid: self.globalVar.selectedJobKey,
          editStatus: self.globalVar.editStatus
        }
        ediApi.getLadingBillEDI(params).then(response => {
          self.commonCallback().onExportEDISuccess(response)
        }).catch(err => {
          self.commonCallback().onExportEDIFail(err)
        }).finally(() => {
          self.loading.close()
        })
      }

      return { btnBlEdiNewClickHandler, btnBlEdiEditClickHandler }
    },
    // 具体操作处理器 === <<<
    // >>> === 公用方法及特殊回调方法
    // EDI公共方法
    common() {
      const self = this
      // configMap检测方法
      const checkConfig = (prop, targetValue) => {
        return self.configMap !== null && self.configMap.get(prop) === targetValue
      }
      // 获取selectedJobs & 拼接各类所需对象
      const getSelectedJobs = () => {
        if (!self.job) {
          return
        }
        // 点击行
        const selectedJob = self.job
        if (selectedJob) {
          self.globalVar.selectedJob = selectedJob
          self.globalVar.selectedJobKey = selectedJob.uuid
        }
      }
      // 显示EDI模板选择弹窗(selectorDialog)
      const showEDITemplateWin = (uuids, item = null) => {
        if (uuids) {
          self.globalVar.ediTemplateWin.uuids = uuids
        } else {
          self.globalVar.ediTemplateWin.item = item
        }
        self.loading = getLoading()
        getEDITemplate({ templateType: this.globalVar.ediType }).then(result => {
          self.selectorDialog.title = self.globalVar.title
          self.selectorDialog.rowData = result.data
          self.selectorDialog.visible = true
        }).finally(() => {
          self.loading.close()
        })
      }
      // 弹出messagePreviewDialog
      const setEdiTabWindow = () => {
        self.messagePreviewDialog.params = {
          job: self.globalVar.selectedJob,
          title: self.globalVar.title,
          ediType: self.globalVar.ediType,
          // ediFileName: self.globalVar,
          ediCollection: self.globalVar.ediDatas,
          ediTemplate: self.globalVar.ediTemplate,
          ediStatusName: self.ediStatusName
        }

        self.messagePreviewDialog.visible = true
      }
      // 判断SeaExportJob是否需要加载CargoDoc
      const needLoadCargoDoc = (job) => {
        return job.uuid && (!job.cargoDoc || job.cargoDoc.length < 1)
      }
      // 判断SeaExportJob是否需要加载Containers
      const needLoadContainers = (job) => {
        return job.uuid && (!job.containers || job.containers.length < 1)
      }
      // 判断数据选择情况(点击行，非勾选)
      const selectedJobItemClick = () => {
        if (!self.globalVar.selectedJobKey) {
          self.$message.warning(this.$t('SeaExport.NoBusinessSelected'))
          return Promise.reject()
        }
      }
      return { checkConfig, getSelectedJobs, showEDITemplateWin, setEdiTabWindow, needLoadCargoDoc, needLoadContainers, selectedJobItemClick }
    },
    // EDI公共回调方法
    commonCallback() {
      const self = this
      // edi导出成功回调方法
      const onExportEDISuccess = (response) => {
        if (!response || !response.data || JSON.stringify(response.data) === '{}') {
          self.$message.warning(this.$t('SeaExport.NoImportEDI'))
          return
        }
        self.globalVar.ediDatas = response.data
        self.common().setEdiTabWindow()
      }
      // edi导出失败回调方法
      const onExportEDIFail = (dataMsg) => {
        if (dataMsg instanceof Error) {
          return
        }
        const modelMap = ModelMap['ProperyLabelMap']
        const errorMsgArr = dataMsg ? dataMsg.split(';') : null
        let finalMessage = ''
        const suffixMsg = this.$t('SeaExport.ItIsEmpty') + '<br/>'
        if (errorMsgArr && errorMsgArr.length > 0) {
          errorMsgArr.forEach(errorMsg => {
            const modelField = errorMsg.split('.')
            if (modelField && modelField.length > 0) {
              const model = modelMap[modelField[0]]
              if (model) {
                finalMessage += (model[modelField[1]] + suffixMsg)
              }
            } else {
              finalMessage += errorMsg
            }
          })
        }
        if (finalMessage) {
          self.$message.error({ dangerouslyUseHTMLString: true, message: finalMessage })
        } else {
          self.$message.error({ dangerouslyUseHTMLString: true, message: dataMsg })
        }
      }
      return { onExportEDISuccess, onExportEDIFail }
    },
    // EDI模板选择弹窗(dialog-selector)选择数据后回调函数
    getEDICallback(row) {
      // 太平引导页面
      if (row && row.bootHelperPage === 1) {
        this.globalVar.ediTemplate = row
        this.ediDocWindow.callBackFunc = this.doEDICallback
        this.ediDocWindow.visible = true
        this.$nextTick(() => {
          this.$refs.ediDocWindow.showDetail(this.job, this.form)
        })
      } else {
        this.doEDICallback(row)
      }
    },
    doEDICallback(row) {
      this.globalVar.ediTemplate = row
      this.globalVar.popMultiSegNumRulesType = 1
      if (this.common().checkConfig('EDINoRuleConfigMode', '1') && this.globalVar.ediType === 5) {
        this.multiSegNumRulesDialog.visible = true
      } else {
        this.multiSegNumRulesCallback(null)
      }
    },
    // 多段号码规则配置弹窗(multi-seg-num-rule-dialog)回调函数入口
    multiSegNumRulesCallback(ruleEDINos) {
      switch (this.globalVar.popMultiSegNumRulesType) {
        case 1: this.multiSegNumRulesCallbackHandler().callbackHandle1(ruleEDINos)
          break
        case 2: this.multiSegNumRulesCallbackHandler().callbackHandle2(ruleEDINos)
          break
      }
    },
    // 多段号码规则配置弹窗(multi-seg-num-rule-dialog)回调函数实际处理方法
    multiSegNumRulesCallbackHandler() {
      const self = this
      // 回调处理方法1, 订舱菜单触发多段号码规则弹窗回调函数
      const callbackHandle1 = (ruleEDINos) => {
        let ruleEDINoArr = []
        if (ruleEDINos && self.common().checkConfig('EDINoRuleConfigMode', '1') && self.globalVar.ediType === 5) {
          ruleEDINoArr = ruleEDINos
        }
        if (self.globalVar.ediTemplateWin.item) {
          self.globalVar.ediTemplateWin.item.ruleEDINos = ruleEDINoArr
          const param = {}
          param.ediType = self.globalVar.ediType
          param.templateId = self.globalVar.ediTemplate.uuid
          param.item = self.globalVar.ediTemplateWin.item
          param.editStatus = self.globalVar.editStatus
          self.loading = getLoading()
          ediApi.getEDIObject(param).then(result => self.commonCallback().onExportEDISuccess(result))
            .catch(message => self.commonCallback().onExportEDIFail(message))
            .finally(() => {
              self.globalVar.ediTemplateWin.item = undefined
              self.loading.close()
            })
        } else {
          const param = {}
          param.ediType = self.globalVar.ediType
          param.templateId = self.globalVar.ediTemplate.uuid
          param.jobUuids = self.globalVar.ediTemplateWin.uuids
          param.editStatus = self.globalVar.editStatus
          param.ruleEDINos = ruleEDINoArr
          this.loading = getLoading()
          ediApi.getEDI(param).then(result => self.commonCallback().onExportEDISuccess(result))
            .catch(message => self.commonCallback().onExportEDIFail(message))
            .finally(() => { self.loading.close() })
        }
      }
      // 回调处理方法2, 舱单菜单触发多段号码规则弹窗回调函数
      const callbackHandle2 = (ruleEDINos) => {
        self.shippingHandler().getShippingEDI(ruleEDINos)
      }
      return { callbackHandle1, callbackHandle2 }
    },
    // api接口集合 原始  state 9：新增  5：修改
    bookingEDIApi(state) {
      this.apiPopup.title = this.$t('SeaExport.Bl') + ' API'
      this.apiPopup.interfaceArray = this.config.get('BillEDIApiOpen')
      this.apiPopup.state = state
      this.apiPopup.interfaceType = 4
      this.apiPopup.visible = true
    },
    selectedApiCallback(row) {
      if (row) {
        const inteface = row['id'].toString()
        if (inteface === '1') {
          if (!this.form.dispatchingPlace || !this.form.dispatchingPlace.trim()) {
            this.$message.warning(this.$t('SeaExport.TheBillOfLadingEmpty'))
            return
          }

          const param = {}
          param.jobUuid = this.job.uuid
          param.editStatus = parseInt(this.apiPopup.state)
          param.sendType = 'IFTMIN'
          if (param.editStatus === 9) {
            param.ediSendType = EdiSendType.EDI_ORIGINAL_API.code
          } else if (param.editStatus === 5) {
            param.ediSendType = EdiSendType.EDI_UPDATE_API.code
          }
          this.loading = getLoading()
          ediApi.getNingBoEportAPI(param).then(result => this.apiSuccess(result)).catch(message => {
            this.$message.error(message)
          }).finally(() => {
            this.loading.close()
          })
        }
      }
    },
    /**
     * 成功
     */
    apiSuccess(event) {
      const o = event.data
      if (o) {
        const success = o.isSuccess
        if (success) {
          this.$message.success(this.$t('SeaExport.RequestSuccessful'))
        } else {
          const text = o.text.toString()
          const textStr = text.substring(0, text.length - 5) + text.substring(text.length - 5, text.length).replace(';', '')
          this.errorLogDialog.errorLog = textStr
          this.errorLogDialog.visible = true
        }
      }
    },
    downloadAttachment(regionWarehouseMappingUuid) {
      JobUtils.downloadPortRequirementAttachment(regionWarehouseMappingUuid)
    },
    ediEuBolInfoHandler() {
      this.ediStatusName = this.$t('SeaExport.EdiEuBolInfo')
      this.cargoDocExtendDialog.title = this.$t('SeaExport.EdiEuBolInfo')
      this.cargoDocExtendDialog.visible = true
    },
    syncContainerInfoDialogHandle() {
      CargoDocUtil.syncContainerHandle(this, this.job, this.form, this.syncContainerInfoDialog)
    },
    syncContainerInfoChangeHandle() {
      // 调用各自原本的方法进行处理
      // 件
      this.pm.quantityChange()
      // 毛
      CargoDocUtil.changeBillOfLadingSynJob(this.job, this.form)
      // 体
      CargoDocUtil.changeBillOfLadingSynJob(this.job, this.form)
      // 计费重量
      CargoDocUtil.calculateSEChargeWeight(this.form)
    },
    // PILL-1056 SEHSCodeMode===1/2 取各自的值， SEHSCodeMode===0 与基本页签同步
    // 因为基本页签的数据修改HBL的数据，所以这里也要处理
    async hsCodeChangeHandle(val) {
      this.job.hsCode = val
      if (this.job.lob === SystemConstants.SE.code && this.SEHSCodeMode === 0) {
        this.form.hsCode = val
        if (this.job.signHBL) {
          const hblDoc = await new SeaExportJob(this.job).getCargoDocByDocType(CargoDocConsts.HBL, false)
          if (hblDoc && hblDoc.state !== 2) {
            hblDoc.hsCode = val
          }
        }
      }
    },
    endTabHandler() {
      CargoDocUtil.syncCargoDocSftToJob(this.job, this.form)
    },
    // 海外代理预报
    toOverseaAgeFore(index) {
      this.selectorDialog.key = 'bl'
      switch (index) {
        case this.$t('SeaExport.Original'):
          this.globalVar.title = this.$t('SeaExport.Original') + this.$t('SeaExport.JclForecast')
          this.ediStatusName = this.$t('SeaExport.Original')
          this.jclHandler(9)
          break
        case this.$t('SeaExport.Correct'):
          this.globalVar.title = this.$t('SeaExport.Correct') + this.$t('SeaExport.JclForecast')
          this.ediStatusName = this.$t('SeaExport.Correct')
          this.jclHandler(5)
          break
        case this.$t('CargoMsg.Cargo_Delete'):
          this.globalVar.title = this.$t('CargoMsg.Cargo_Delete') + this.$t('SeaExport.JclForecast')
          this.ediStatusName = this.$t('CargoMsg.Cargo_Delete')
          this.jclHandler(1)
          break
        default:
          break
      }
    },
    // 预配舱单操作处理器
    jclHandler(state) {
      this.common(this).getSelectedJobs()
      this.globalVar.editStatus = state
      this.globalVar.ediType = EdiType.JCL_EDI_TYPE.code
      this.globalVar.ediTemplate = {}
      this.globalVar.ediTemplate.defaultFileType = '.xml'
      if (this.common().checkConfig('useEDITemplate', '1')) {
        this.common().showEDITemplateWin([this.job.uuid])
      } else {
        const params = { jobUuids: [this.job.uuid], editStatus: this.globalVar.editStatus, ediType: this.globalVar.ediType, templateId: this.globalVar.ediTemplate.uuid }
        this.loading = getLoading4Cxt(this)
        ediApi.getEDI(params).then(response => {
          this.commonCallback().onExportEDISuccess(response)
        }).catch(err => {
          this.commonCallback().onExportEDIFail(err)
        }).finally(() => {
          this.loading.close()
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
/deep/ .el-submenu__title{
  border-bottom: none !important;
}
.mbl-red::v-deep{
  .el-input__inner {
    color: red !important;
  }
}
.form-column{
  .form-item-input{
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    background-color: #fff;
    border: 1px solid #E4E7ED;
    span{
      width: 40px;
      height: 28px;
      line-height: 26px;
      box-sizing: border-box;
      padding-left: 5px;
      padding-top: 1px;
    }
    /deep/ input{
      border: 0;
      padding-right: 0 !important;
    }
  }
  .input-disabled{
    background-color: #f0f3f8 !important;
    cursor: not-allowed;
  }
}
.red-border {
  /deep/ .el-input__inner,
  /deep/ .el-textarea__inner,
  /deep/ .cargo-rich-textarea{
    border: 1px solid red !important;
  }
}
</style>
